"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const GetTransferInternalError_1 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_2 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_3 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_4 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_5 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_6 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferInternalError_7 = require("./types/GetTransferInternal/GetTransferInternalError");
const GetTransferPreviewError_1 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_2 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_3 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_4 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_5 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_6 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_7 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_8 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_9 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_10 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferPreviewError_11 = require("./types/GetTransferPreview/GetTransferPreviewError");
const GetTransferQueueError_1 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_2 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_3 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_4 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_5 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_6 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferQueueError_7 = require("./types/GetTransferQueue/GetTransferQueueError");
const GetTransferUserError_1 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_2 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_3 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_4 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_5 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_6 = require("./types/GetTransferUser/GetTransferUserError");
const GetTransferUserError_7 = require("./types/GetTransferUser/GetTransferUserError");
const GetUsageError_1 = require("./types/GetUsage/GetUsageError");
const GetUsageError_2 = require("./types/GetUsage/GetUsageError");
const GetUsageError_3 = require("./types/GetUsage/GetUsageError");
const GetUsageError_4 = require("./types/GetUsage/GetUsageError");
const GetUsageError_5 = require("./types/GetUsage/GetUsageError");
const GetUserDropboxError_1 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_2 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_3 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_4 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_5 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_6 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserDropboxError_7 = require("./types/GetUserDropbox/GetUserDropboxError");
const GetUserMetricStatisticError_1 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserMetricStatisticError_2 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserMetricStatisticError_3 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserMetricStatisticError_4 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserMetricStatisticError_5 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserMetricStatisticError_6 = require("./types/GetUserMetricStatistic/GetUserMetricStatisticError");
const GetUserReceiptError_1 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_2 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_3 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_4 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_5 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_6 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptError_7 = require("./types/GetUserReceipt/GetUserReceiptError");
const GetUserReceiptFileError_1 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_2 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_3 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_4 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_5 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_6 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserReceiptFileError_7 = require("./types/GetUserReceiptFile/GetUserReceiptFileError");
const GetUserTransferError_1 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_2 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_3 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_4 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_5 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_6 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferError_7 = require("./types/GetUserTransfer/GetUserTransferError");
const GetUserTransferFileError_1 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_2 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_3 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_4 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_5 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_6 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserTransferFileError_7 = require("./types/GetUserTransferFile/GetUserTransferFileError");
const GetUserUsageError_1 = require("./types/GetUserUsage/GetUserUsageError");
const GetUserUsageError_2 = require("./types/GetUserUsage/GetUserUsageError");
const GetUserUsageError_3 = require("./types/GetUserUsage/GetUserUsageError");
const GetUserUsageError_4 = require("./types/GetUserUsage/GetUserUsageError");
const GetUserUsageError_5 = require("./types/GetUserUsage/GetUserUsageError");
const GetUserUsageError_6 = require("./types/GetUserUsage/GetUserUsageError");
const ListAccountTransfersError_1 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListAccountTransfersError_2 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListAccountTransfersError_3 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListAccountTransfersError_4 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListAccountTransfersError_5 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListAccountTransfersError_6 = require("./types/ListAccountTransfers/ListAccountTransfersError");
const ListDayEventsError_1 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayEventsError_2 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayEventsError_3 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayEventsError_4 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayEventsError_5 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayEventsError_6 = require("./types/ListDayEvents/ListDayEventsError");
const ListDayFilesError_1 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayFilesError_2 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayFilesError_3 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayFilesError_4 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayFilesError_5 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayFilesError_6 = require("./types/ListDayFiles/ListDayFilesError");
const ListDayTransfersError_1 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDayTransfersError_2 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDayTransfersError_3 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDayTransfersError_4 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDayTransfersError_5 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDayTransfersError_6 = require("./types/ListDayTransfers/ListDayTransfersError");
const ListDropboxesError_1 = require("./types/ListDropboxes/ListDropboxesError");
const ListDropboxesError_2 = require("./types/ListDropboxes/ListDropboxesError");
const ListDropboxesError_3 = require("./types/ListDropboxes/ListDropboxesError");
const ListDropboxesError_4 = require("./types/ListDropboxes/ListDropboxesError");
const ListDropboxesError_5 = require("./types/ListDropboxes/ListDropboxesError");
const ListDropboxesError_6 = require("./types/ListDropboxes/ListDropboxesError");
const ListHourEventsError_1 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourEventsError_2 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourEventsError_3 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourEventsError_4 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourEventsError_5 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourEventsError_6 = require("./types/ListHourEvents/ListHourEventsError");
const ListHourFilesError_1 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourFilesError_2 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourFilesError_3 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourFilesError_4 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourFilesError_5 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourFilesError_6 = require("./types/ListHourFiles/ListHourFilesError");
const ListHourTransfersError_1 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListHourTransfersError_2 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListHourTransfersError_3 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListHourTransfersError_4 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListHourTransfersError_5 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListHourTransfersError_6 = require("./types/ListHourTransfers/ListHourTransfersError");
const ListManualReviewsError_1 = require("./types/ListManualReviews/ListManualReviewsError");
const ListManualReviewsError_2 = require("./types/ListManualReviews/ListManualReviewsError");
const ListManualReviewsError_3 = require("./types/ListManualReviews/ListManualReviewsError");
const ListManualReviewsError_4 = require("./types/ListManualReviews/ListManualReviewsError");
const ListManualReviewsError_5 = require("./types/ListManualReviews/ListManualReviewsError");
const ListMonthEventsError_1 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthEventsError_2 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthEventsError_3 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthEventsError_4 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthEventsError_5 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthEventsError_6 = require("./types/ListMonthEvents/ListMonthEventsError");
const ListMonthFilesError_1 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthFilesError_2 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthFilesError_3 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthFilesError_4 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthFilesError_5 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthFilesError_6 = require("./types/ListMonthFiles/ListMonthFilesError");
const ListMonthTransfersError_1 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListMonthTransfersError_2 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListMonthTransfersError_3 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListMonthTransfersError_4 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListMonthTransfersError_5 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListMonthTransfersError_6 = require("./types/ListMonthTransfers/ListMonthTransfersError");
const ListReceiptFilesError_1 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_2 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_3 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_4 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_5 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_6 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptFilesError_7 = require("./types/ListReceiptFiles/ListReceiptFilesError");
const ListReceiptsError_1 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiptsError_2 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiptsError_3 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiptsError_4 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiptsError_5 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiptsError_6 = require("./types/ListReceipts/ListReceiptsError");
const ListReceiverTransfersError_1 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_2 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_3 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_4 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_5 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_6 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListReceiverTransfersError_7 = require("./types/ListReceiverTransfers/ListReceiverTransfersError");
const ListSenderTransfersError_1 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListSenderTransfersError_2 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListSenderTransfersError_3 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListSenderTransfersError_4 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListSenderTransfersError_5 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListSenderTransfersError_6 = require("./types/ListSenderTransfers/ListSenderTransfersError");
const ListTeamDropboxesError_1 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamDropboxesError_2 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamDropboxesError_3 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamDropboxesError_4 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamDropboxesError_5 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamDropboxesError_6 = require("./types/ListTeamDropboxes/ListTeamDropboxesError");
const ListTeamReceiptFilesError_1 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_2 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_3 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_4 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_5 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_6 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_7 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptFilesError_8 = require("./types/ListTeamReceiptFiles/ListTeamReceiptFilesError");
const ListTeamReceiptsError_1 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamReceiptsError_2 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamReceiptsError_3 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamReceiptsError_4 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamReceiptsError_5 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamReceiptsError_6 = require("./types/ListTeamReceipts/ListTeamReceiptsError");
const ListTeamTransferEventsError_1 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_2 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_3 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_4 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_5 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_6 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferEventsError_7 = require("./types/ListTeamTransferEvents/ListTeamTransferEventsError");
const ListTeamTransferFilesError_1 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_2 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_3 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_4 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_5 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_6 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_7 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransferFilesError_8 = require("./types/ListTeamTransferFiles/ListTeamTransferFilesError");
const ListTeamTransfersError_1 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_2 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_3 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_4 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_5 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_6 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_7 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamTransfersError_8 = require("./types/ListTeamTransfers/ListTeamTransfersError");
const ListTeamUserDropboxesError_1 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserDropboxesError_2 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserDropboxesError_3 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserDropboxesError_4 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserDropboxesError_5 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserDropboxesError_6 = require("./types/ListTeamUserDropboxes/ListTeamUserDropboxesError");
const ListTeamUserReceiptFilesError_1 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_2 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_3 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_4 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_5 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_6 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_7 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptFilesError_8 = require("./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError");
const ListTeamUserReceiptsError_1 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserReceiptsError_2 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserReceiptsError_3 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserReceiptsError_4 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserReceiptsError_5 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserReceiptsError_6 = require("./types/ListTeamUserReceipts/ListTeamUserReceiptsError");
const ListTeamUserTransfersError_1 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTeamUserTransfersError_2 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTeamUserTransfersError_3 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTeamUserTransfersError_4 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTeamUserTransfersError_5 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTeamUserTransfersError_6 = require("./types/ListTeamUserTransfers/ListTeamUserTransfersError");
const ListTransferEventsError_1 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_2 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_3 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_4 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_5 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_6 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferEventsError_7 = require("./types/ListTransferEvents/ListTransferEventsError");
const ListTransferFilesError_1 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_2 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_3 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_4 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_5 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_6 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesError_7 = require("./types/ListTransferFiles/ListTransferFilesError");
const ListTransferFilesInternalError_1 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_2 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_3 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_4 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_5 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_6 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesInternalError_7 = require("./types/ListTransferFilesInternal/ListTransferFilesInternalError");
const ListTransferFilesPreviewError_1 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_2 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_3 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_4 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_5 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_6 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_7 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_8 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_9 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransferFilesPreviewError_10 = require("./types/ListTransferFilesPreview/ListTransferFilesPreviewError");
const ListTransfersError_1 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_2 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_3 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_4 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_5 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_6 = require("./types/ListTransfers/ListTransfersError");
const ListTransfersError_7 = require("./types/ListTransfers/ListTransfersError");
const ListUserDropboxesError_1 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserDropboxesError_2 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserDropboxesError_3 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserDropboxesError_4 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserDropboxesError_5 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserDropboxesError_6 = require("./types/ListUserDropboxes/ListUserDropboxesError");
const ListUserReceiptFilesError_1 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_2 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_3 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_4 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_5 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_6 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptFilesError_7 = require("./types/ListUserReceiptFiles/ListUserReceiptFilesError");
const ListUserReceiptsError_1 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserReceiptsError_2 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserReceiptsError_3 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserReceiptsError_4 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserReceiptsError_5 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserReceiptsError_6 = require("./types/ListUserReceipts/ListUserReceiptsError");
const ListUserTransferEventsError_1 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_2 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_3 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_4 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_5 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_6 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferEventsError_7 = require("./types/ListUserTransferEvents/ListUserTransferEventsError");
const ListUserTransferFilesError_1 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_2 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_3 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_4 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_5 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_6 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransferFilesError_7 = require("./types/ListUserTransferFiles/ListUserTransferFilesError");
const ListUserTransfersError_1 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_2 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_3 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_4 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_5 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_6 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListUserTransfersError_7 = require("./types/ListUserTransfers/ListUserTransfersError");
const ListYearEventsError_1 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearEventsError_2 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearEventsError_3 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearEventsError_4 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearEventsError_5 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearEventsError_6 = require("./types/ListYearEvents/ListYearEventsError");
const ListYearFilesError_1 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearFilesError_2 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearFilesError_3 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearFilesError_4 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearFilesError_5 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearFilesError_6 = require("./types/ListYearFiles/ListYearFilesError");
const ListYearTransfersError_1 = require("./types/ListYearTransfers/ListYearTransfersError");
const ListYearTransfersError_2 = require("./types/ListYearTransfers/ListYearTransfersError");
const ListYearTransfersError_3 = require("./types/ListYearTransfers/ListYearTransfersError");
const ListYearTransfersError_4 = require("./types/ListYearTransfers/ListYearTransfersError");
const ListYearTransfersError_5 = require("./types/ListYearTransfers/ListYearTransfersError");
const ListYearTransfersError_6 = require("./types/ListYearTransfers/ListYearTransfersError");
const LockTransferError_1 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_2 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_3 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_4 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_5 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_6 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_7 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_8 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_9 = require("./types/LockTransfer/LockTransferError");
const LockTransferError_10 = require("./types/LockTransfer/LockTransferError");
const UpdateDropboxError_1 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_2 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_3 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_4 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_5 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_6 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateDropboxError_7 = require("./types/UpdateDropbox/UpdateDropboxError");
const UpdateManualReviewError_1 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_2 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_3 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_4 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_5 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_6 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateManualReviewError_7 = require("./types/UpdateManualReview/UpdateManualReviewError");
const UpdateTeamDropboxError_1 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_2 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_3 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_4 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_5 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_6 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamDropboxError_7 = require("./types/UpdateTeamDropbox/UpdateTeamDropboxError");
const UpdateTeamUserDropboxError_1 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_2 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_3 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_4 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_5 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_6 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTeamUserDropboxError_7 = require("./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError");
const UpdateTransferError_1 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_2 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_3 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_4 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_5 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_6 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_7 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferError_8 = require("./types/UpdateTransfer/UpdateTransferError");
const UpdateTransferCustomizationError_1 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_2 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_3 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_4 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_5 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_6 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferCustomizationError_7 = require("./types/UpdateTransferCustomization/UpdateTransferCustomizationError");
const UpdateTransferFileError_1 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_2 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_3 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_4 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_5 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_6 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_7 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_8 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFileError_9 = require("./types/UpdateTransferFile/UpdateTransferFileError");
const UpdateTransferFilePartError_1 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_2 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_3 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_4 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_5 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_6 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_7 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_8 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartError_9 = require("./types/UpdateTransferFilePart/UpdateTransferFilePartError");
const UpdateTransferFilePartsError_1 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_2 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_3 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_4 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_5 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_6 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_7 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_8 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateTransferFilePartsError_9 = require("./types/UpdateTransferFileParts/UpdateTransferFilePartsError");
const UpdateUserDropboxError_1 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_2 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_3 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_4 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_5 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_6 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const UpdateUserDropboxError_7 = require("./types/UpdateUserDropbox/UpdateUserDropboxError");
const CreateDropboxError_1 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_2 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_3 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_4 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_5 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_6 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxError_7 = require("./types/CreateDropbox/CreateDropboxError");
const CreateDropboxTransferError_1 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_2 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_3 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_4 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_5 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_6 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_7 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_8 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_9 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_10 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_11 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_12 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_13 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_14 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_15 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_16 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_17 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_18 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_19 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_20 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateDropboxTransferError_21 = require("./types/CreateDropboxTransfer/CreateDropboxTransferError");
const CreateTeamDropboxError_1 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_2 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_3 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_4 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_5 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_6 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_7 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamDropboxError_8 = require("./types/CreateTeamDropbox/CreateTeamDropboxError");
const CreateTeamTransferError_1 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_2 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_3 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_4 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_5 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_6 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_7 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_8 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_9 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_10 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_11 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_12 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_13 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_14 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamTransferError_15 = require("./types/CreateTeamTransfer/CreateTeamTransferError");
const CreateTeamUserDropboxError_1 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_2 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_3 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_4 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_5 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_6 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_7 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTeamUserDropboxError_8 = require("./types/CreateTeamUserDropbox/CreateTeamUserDropboxError");
const CreateTransferError_1 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_2 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_3 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_4 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_5 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_6 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_7 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_8 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_9 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_10 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_11 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_12 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_13 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_14 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_15 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferError_16 = require("./types/CreateTransfer/CreateTransferError");
const CreateTransferFileError_1 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_2 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_3 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_4 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_5 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_6 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_7 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_8 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_9 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFileError_10 = require("./types/CreateTransferFile/CreateTransferFileError");
const CreateTransferFilePartError_1 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_2 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_3 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_4 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_5 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_6 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_7 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_8 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartError_9 = require("./types/CreateTransferFilePart/CreateTransferFilePartError");
const CreateTransferFilePartsError_1 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_2 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_3 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_4 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_5 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_6 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_7 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_8 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferFilePartsError_9 = require("./types/CreateTransferFileParts/CreateTransferFilePartsError");
const CreateTransferSignedUrlsError_1 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_2 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_3 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_4 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_5 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_6 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_7 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateTransferSignedUrlsError_8 = require("./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError");
const CreateUserDropboxError_1 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_2 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_3 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_4 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_5 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_6 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_7 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const CreateUserDropboxError_8 = require("./types/CreateUserDropbox/CreateUserDropboxError");
const DeleteDropboxError_1 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_2 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_3 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_4 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_5 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_6 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteDropboxError_7 = require("./types/DeleteDropbox/DeleteDropboxError");
const DeleteReceiptError_1 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_2 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_3 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_4 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_5 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_6 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReceiptError_7 = require("./types/DeleteReceipt/DeleteReceiptError");
const DeleteReportError_1 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_2 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_3 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_4 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_5 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_6 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_7 = require("./types/DeleteReport/DeleteReportError");
const DeleteReportError_8 = require("./types/DeleteReport/DeleteReportError");
const DeleteTeamDropboxError_1 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_2 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_3 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_4 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_5 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_6 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamDropboxError_7 = require("./types/DeleteTeamDropbox/DeleteTeamDropboxError");
const DeleteTeamReceiptError_1 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_2 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_3 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_4 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_5 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_6 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamReceiptError_7 = require("./types/DeleteTeamReceipt/DeleteTeamReceiptError");
const DeleteTeamTransferError_1 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_2 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_3 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_4 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_5 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_6 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_7 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamTransferError_8 = require("./types/DeleteTeamTransfer/DeleteTeamTransferError");
const DeleteTeamUserDropboxError_1 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_2 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_3 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_4 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_5 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_6 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserDropboxError_7 = require("./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError");
const DeleteTeamUserReceiptError_1 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_2 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_3 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_4 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_5 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_6 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTeamUserReceiptError_7 = require("./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError");
const DeleteTransferError_1 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_2 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_3 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_4 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_5 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_6 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_7 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferError_8 = require("./types/DeleteTransfer/DeleteTransferError");
const DeleteTransferFileError_1 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_2 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_3 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_4 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_5 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_6 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteTransferFileError_7 = require("./types/DeleteTransferFile/DeleteTransferFileError");
const DeleteUserDropboxError_1 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_2 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_3 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_4 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_5 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_6 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserDropboxError_7 = require("./types/DeleteUserDropbox/DeleteUserDropboxError");
const DeleteUserReceiptError_1 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_2 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_3 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_4 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_5 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_6 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserReceiptError_7 = require("./types/DeleteUserReceipt/DeleteUserReceiptError");
const DeleteUserTransferError_1 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_2 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_3 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_4 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_5 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_6 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_7 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const DeleteUserTransferError_8 = require("./types/DeleteUserTransfer/DeleteUserTransferError");
const GetAccountMetricStatisticError_1 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_2 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_3 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_4 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_5 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_6 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountMetricStatisticError_7 = require("./types/GetAccountMetricStatistic/GetAccountMetricStatisticError");
const GetAccountTeamMetricStatisticError_1 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_2 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_3 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_4 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_5 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_6 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamMetricStatisticError_7 = require("./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError");
const GetAccountTeamUsageError_1 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUsageError_2 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUsageError_3 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUsageError_4 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUsageError_5 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUsageError_6 = require("./types/GetAccountTeamUsage/GetAccountTeamUsageError");
const GetAccountTeamUserMetricStatisticError_1 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_2 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_3 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_4 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_5 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_6 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserMetricStatisticError_7 = require("./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError");
const GetAccountTeamUserUsageError_1 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTeamUserUsageError_2 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTeamUserUsageError_3 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTeamUserUsageError_4 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTeamUserUsageError_5 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTeamUserUsageError_6 = require("./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError");
const GetAccountTransferError_1 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_2 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_3 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_4 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_5 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_6 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountTransferError_7 = require("./types/GetAccountTransfer/GetAccountTransferError");
const GetAccountUsageError_1 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUsageError_2 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUsageError_3 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUsageError_4 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUsageError_5 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUsageError_6 = require("./types/GetAccountUsage/GetAccountUsageError");
const GetAccountUserMetricStatisticError_1 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_2 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_3 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_4 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_5 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_6 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserMetricStatisticError_7 = require("./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError");
const GetAccountUserUsageError_1 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetAccountUserUsageError_2 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetAccountUserUsageError_3 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetAccountUserUsageError_4 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetAccountUserUsageError_5 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetAccountUserUsageError_6 = require("./types/GetAccountUserUsage/GetAccountUserUsageError");
const GetDropboxError_1 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_2 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_3 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_4 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_5 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_6 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxError_7 = require("./types/GetDropbox/GetDropboxError");
const GetDropboxPreviewError_1 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_2 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_3 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_4 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_5 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_6 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_7 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_8 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_9 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_10 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_11 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_12 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_13 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetDropboxPreviewError_14 = require("./types/GetDropboxPreview/GetDropboxPreviewError");
const GetManualReviewError_1 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_2 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_3 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_4 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_5 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_6 = require("./types/GetManualReview/GetManualReviewError");
const GetManualReviewError_7 = require("./types/GetManualReview/GetManualReviewError");
const GetMetricStatisticError_1 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetMetricStatisticError_2 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetMetricStatisticError_3 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetMetricStatisticError_4 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetMetricStatisticError_5 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetMetricStatisticError_6 = require("./types/GetMetricStatistic/GetMetricStatisticError");
const GetReceiptError_1 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_2 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_3 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_4 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_5 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_6 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptError_7 = require("./types/GetReceipt/GetReceiptError");
const GetReceiptFileError_1 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_2 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_3 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_4 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_5 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_6 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReceiptFileError_7 = require("./types/GetReceiptFile/GetReceiptFileError");
const GetReportError_1 = require("./types/GetReport/GetReportError");
const GetReportError_2 = require("./types/GetReport/GetReportError");
const GetReportError_3 = require("./types/GetReport/GetReportError");
const GetReportError_4 = require("./types/GetReport/GetReportError");
const GetReportError_5 = require("./types/GetReport/GetReportError");
const GetReportError_6 = require("./types/GetReport/GetReportError");
const GetReportError_7 = require("./types/GetReport/GetReportError");
const GetTeamDropboxError_1 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_2 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_3 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_4 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_5 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_6 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamDropboxError_7 = require("./types/GetTeamDropbox/GetTeamDropboxError");
const GetTeamMetricStatisticError_1 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamMetricStatisticError_2 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamMetricStatisticError_3 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamMetricStatisticError_4 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamMetricStatisticError_5 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamMetricStatisticError_6 = require("./types/GetTeamMetricStatistic/GetTeamMetricStatisticError");
const GetTeamReceiptError_1 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_2 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_3 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_4 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_5 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_6 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptError_7 = require("./types/GetTeamReceipt/GetTeamReceiptError");
const GetTeamReceiptFileError_1 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_2 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_3 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_4 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_5 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_6 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_7 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamReceiptFileError_8 = require("./types/GetTeamReceiptFile/GetTeamReceiptFileError");
const GetTeamTransferError_1 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_2 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_3 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_4 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_5 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_6 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferError_7 = require("./types/GetTeamTransfer/GetTeamTransferError");
const GetTeamTransferFileError_1 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_2 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_3 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_4 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_5 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_6 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_7 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferFileError_8 = require("./types/GetTeamTransferFile/GetTeamTransferFileError");
const GetTeamTransferQueueError_1 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_2 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_3 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_4 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_5 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_6 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamTransferQueueError_7 = require("./types/GetTeamTransferQueue/GetTeamTransferQueueError");
const GetTeamUsageError_1 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUsageError_2 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUsageError_3 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUsageError_4 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUsageError_5 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUsageError_6 = require("./types/GetTeamUsage/GetTeamUsageError");
const GetTeamUserDropboxError_1 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_2 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_3 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_4 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_5 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_6 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserDropboxError_7 = require("./types/GetTeamUserDropbox/GetTeamUserDropboxError");
const GetTeamUserMetricStatisticError_1 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserMetricStatisticError_2 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserMetricStatisticError_3 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserMetricStatisticError_4 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserMetricStatisticError_5 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserMetricStatisticError_6 = require("./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError");
const GetTeamUserReceiptError_1 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_2 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_3 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_4 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_5 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_6 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptError_7 = require("./types/GetTeamUserReceipt/GetTeamUserReceiptError");
const GetTeamUserReceiptFileError_1 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_2 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_3 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_4 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_5 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_6 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_7 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserReceiptFileError_8 = require("./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError");
const GetTeamUserTransferError_1 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_2 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_3 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_4 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_5 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_6 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserTransferError_7 = require("./types/GetTeamUserTransfer/GetTeamUserTransferError");
const GetTeamUserUsageError_1 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTeamUserUsageError_2 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTeamUserUsageError_3 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTeamUserUsageError_4 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTeamUserUsageError_5 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTeamUserUsageError_6 = require("./types/GetTeamUserUsage/GetTeamUserUsageError");
const GetTransferError_1 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_2 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_3 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_4 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_5 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_6 = require("./types/GetTransfer/GetTransferError");
const GetTransferError_7 = require("./types/GetTransfer/GetTransferError");
const GetTransferFileError_1 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_2 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_3 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_4 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_5 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_6 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileError_7 = require("./types/GetTransferFile/GetTransferFileError");
const GetTransferFileInternalError_1 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_2 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_3 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_4 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_5 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_6 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFileInternalError_7 = require("./types/GetTransferFileInternal/GetTransferFileInternalError");
const GetTransferFilePreviewError_1 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_2 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_3 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_4 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_5 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_6 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_7 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const GetTransferFilePreviewError_8 = require("./types/GetTransferFilePreview/GetTransferFilePreviewError");
const DownloadError_1 = require("./types/Download/DownloadError");
const DownloadError_2 = require("./types/Download/DownloadError");
const DownloadError_3 = require("./types/Download/DownloadError");
const DownloadError_4 = require("./types/Download/DownloadError");
const DownloadError_5 = require("./types/Download/DownloadError");
const DownloadError_6 = require("./types/Download/DownloadError");
const DownloadError_7 = require("./types/Download/DownloadError");
const DownloadError_8 = require("./types/Download/DownloadError");
const UploadTransferFilePartError_1 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_2 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_3 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_4 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_5 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_6 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_7 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_8 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_9 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_10 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_11 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_12 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_13 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_14 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_15 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_16 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_17 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_18 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_19 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_20 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_21 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_22 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_23 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_24 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_25 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_26 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_27 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_28 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_29 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_30 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_31 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_32 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_33 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_34 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_35 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_36 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_37 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_38 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_39 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_40 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_41 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_42 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_43 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_44 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_45 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_46 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_47 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_48 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_49 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_50 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_51 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_52 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_53 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_54 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_55 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_56 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_57 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_58 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
const UploadTransferFilePartError_59 = require("./types/UploadTransferFilePart/UploadTransferFilePartError");
exports.errors = {
    GetTransferInternal: {
        InvalidParameterError: GetTransferInternalError_2.InvalidParameterError,
        UnauthorizedError: GetTransferInternalError_3.UnauthorizedError,
        NotFoundError: GetTransferInternalError_4.NotFoundError,
        InternalServerError: GetTransferInternalError_5.InternalServerError,
        BadGatewayError: GetTransferInternalError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferInternalError_7.GatewayTimeoutError,
        GenericError: GetTransferInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferPreview: {
        InvalidParameterError: GetTransferPreviewError_2.InvalidParameterError,
        UnauthorizedError: GetTransferPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetTransferPreviewError_4.PasswordDoesNotMatchError,
        InvalidEmailError: GetTransferPreviewError_5.InvalidEmailError,
        OwnerUsageExceededError: GetTransferPreviewError_6.OwnerUsageExceededError,
        AccessorUsageExceededError: GetTransferPreviewError_7.AccessorUsageExceededError,
        NotFoundError: GetTransferPreviewError_8.NotFoundError,
        InternalServerError: GetTransferPreviewError_9.InternalServerError,
        BadGatewayError: GetTransferPreviewError_10.BadGatewayError,
        GatewayTimeoutError: GetTransferPreviewError_11.GatewayTimeoutError,
        GenericError: GetTransferPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferQueue: {
        InvalidParameterError: GetTransferQueueError_2.InvalidParameterError,
        UnauthorizedError: GetTransferQueueError_3.UnauthorizedError,
        NotFoundError: GetTransferQueueError_4.NotFoundError,
        InternalServerError: GetTransferQueueError_5.InternalServerError,
        BadGatewayError: GetTransferQueueError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferQueueError_7.GatewayTimeoutError,
        GenericError: GetTransferQueueError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferUser: {
        InvalidParameterError: GetTransferUserError_2.InvalidParameterError,
        UnauthorizedError: GetTransferUserError_3.UnauthorizedError,
        NotFoundError: GetTransferUserError_4.NotFoundError,
        InternalServerError: GetTransferUserError_5.InternalServerError,
        BadGatewayError: GetTransferUserError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferUserError_7.GatewayTimeoutError,
        GenericError: GetTransferUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUsage: {
        UnauthorizedError: GetUsageError_2.UnauthorizedError,
        InternalServerError: GetUsageError_3.InternalServerError,
        BadGatewayError: GetUsageError_4.BadGatewayError,
        GatewayTimeoutError: GetUsageError_5.GatewayTimeoutError,
        GenericError: GetUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserDropbox: {
        InvalidParameterError: GetUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetUserDropboxError_3.UnauthorizedError,
        NotFoundError: GetUserDropboxError_4.NotFoundError,
        InternalServerError: GetUserDropboxError_5.InternalServerError,
        BadGatewayError: GetUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetUserDropboxError_7.GatewayTimeoutError,
        GenericError: GetUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserMetricStatistic: {
        InvalidParameterError: GetUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetUserMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetUserMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetUserMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetUserMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserReceipt: {
        InvalidParameterError: GetUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetUserReceiptError_3.UnauthorizedError,
        NotFoundError: GetUserReceiptError_4.NotFoundError,
        InternalServerError: GetUserReceiptError_5.InternalServerError,
        BadGatewayError: GetUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetUserReceiptError_7.GatewayTimeoutError,
        GenericError: GetUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserReceiptFile: {
        InvalidParameterError: GetUserReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetUserReceiptFileError_3.UnauthorizedError,
        NotFoundError: GetUserReceiptFileError_4.NotFoundError,
        InternalServerError: GetUserReceiptFileError_5.InternalServerError,
        BadGatewayError: GetUserReceiptFileError_6.BadGatewayError,
        GatewayTimeoutError: GetUserReceiptFileError_7.GatewayTimeoutError,
        GenericError: GetUserReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserTransfer: {
        InvalidParameterError: GetUserTransferError_2.InvalidParameterError,
        UnauthorizedError: GetUserTransferError_3.UnauthorizedError,
        NotFoundError: GetUserTransferError_4.NotFoundError,
        InternalServerError: GetUserTransferError_5.InternalServerError,
        BadGatewayError: GetUserTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetUserTransferError_7.GatewayTimeoutError,
        GenericError: GetUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserTransferFile: {
        InvalidParameterError: GetUserTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetUserTransferFileError_3.UnauthorizedError,
        NotFoundError: GetUserTransferFileError_4.NotFoundError,
        InternalServerError: GetUserTransferFileError_5.InternalServerError,
        BadGatewayError: GetUserTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: GetUserTransferFileError_7.GatewayTimeoutError,
        GenericError: GetUserTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserUsage: {
        InvalidParameterError: GetUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetUserUsageError_3.UnauthorizedError,
        InternalServerError: GetUserUsageError_4.InternalServerError,
        BadGatewayError: GetUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetUserUsageError_6.GatewayTimeoutError,
        GenericError: GetUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListAccountTransfers: {
        InvalidParameterError: ListAccountTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListAccountTransfersError_3.UnauthorizedError,
        InternalServerError: ListAccountTransfersError_4.InternalServerError,
        BadGatewayError: ListAccountTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListAccountTransfersError_6.GatewayTimeoutError,
        GenericError: ListAccountTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayEvents: {
        InvalidParameterError: ListDayEventsError_2.InvalidParameterError,
        UnauthorizedError: ListDayEventsError_3.UnauthorizedError,
        InternalServerError: ListDayEventsError_4.InternalServerError,
        BadGatewayError: ListDayEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListDayEventsError_6.GatewayTimeoutError,
        GenericError: ListDayEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayFiles: {
        InvalidParameterError: ListDayFilesError_2.InvalidParameterError,
        UnauthorizedError: ListDayFilesError_3.UnauthorizedError,
        InternalServerError: ListDayFilesError_4.InternalServerError,
        BadGatewayError: ListDayFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListDayFilesError_6.GatewayTimeoutError,
        GenericError: ListDayFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayTransfers: {
        InvalidParameterError: ListDayTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListDayTransfersError_3.UnauthorizedError,
        InternalServerError: ListDayTransfersError_4.InternalServerError,
        BadGatewayError: ListDayTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListDayTransfersError_6.GatewayTimeoutError,
        GenericError: ListDayTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDropboxes: {
        InvalidParameterError: ListDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListDropboxesError_3.UnauthorizedError,
        InternalServerError: ListDropboxesError_4.InternalServerError,
        BadGatewayError: ListDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListDropboxesError_6.GatewayTimeoutError,
        GenericError: ListDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourEvents: {
        InvalidParameterError: ListHourEventsError_2.InvalidParameterError,
        UnauthorizedError: ListHourEventsError_3.UnauthorizedError,
        InternalServerError: ListHourEventsError_4.InternalServerError,
        BadGatewayError: ListHourEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListHourEventsError_6.GatewayTimeoutError,
        GenericError: ListHourEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourFiles: {
        InvalidParameterError: ListHourFilesError_2.InvalidParameterError,
        UnauthorizedError: ListHourFilesError_3.UnauthorizedError,
        InternalServerError: ListHourFilesError_4.InternalServerError,
        BadGatewayError: ListHourFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListHourFilesError_6.GatewayTimeoutError,
        GenericError: ListHourFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourTransfers: {
        InvalidParameterError: ListHourTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListHourTransfersError_3.UnauthorizedError,
        InternalServerError: ListHourTransfersError_4.InternalServerError,
        BadGatewayError: ListHourTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListHourTransfersError_6.GatewayTimeoutError,
        GenericError: ListHourTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListManualReviews: {
        UnauthorizedError: ListManualReviewsError_2.UnauthorizedError,
        InternalServerError: ListManualReviewsError_3.InternalServerError,
        BadGatewayError: ListManualReviewsError_4.BadGatewayError,
        GatewayTimeoutError: ListManualReviewsError_5.GatewayTimeoutError,
        GenericError: ListManualReviewsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthEvents: {
        InvalidParameterError: ListMonthEventsError_2.InvalidParameterError,
        UnauthorizedError: ListMonthEventsError_3.UnauthorizedError,
        InternalServerError: ListMonthEventsError_4.InternalServerError,
        BadGatewayError: ListMonthEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthEventsError_6.GatewayTimeoutError,
        GenericError: ListMonthEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthFiles: {
        InvalidParameterError: ListMonthFilesError_2.InvalidParameterError,
        UnauthorizedError: ListMonthFilesError_3.UnauthorizedError,
        InternalServerError: ListMonthFilesError_4.InternalServerError,
        BadGatewayError: ListMonthFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthFilesError_6.GatewayTimeoutError,
        GenericError: ListMonthFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthTransfers: {
        InvalidParameterError: ListMonthTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListMonthTransfersError_3.UnauthorizedError,
        InternalServerError: ListMonthTransfersError_4.InternalServerError,
        BadGatewayError: ListMonthTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthTransfersError_6.GatewayTimeoutError,
        GenericError: ListMonthTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceiptFiles: {
        InvalidParameterError: ListReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListReceiptFilesError_3.UnauthorizedError,
        NotFoundError: ListReceiptFilesError_4.NotFoundError,
        InternalServerError: ListReceiptFilesError_5.InternalServerError,
        BadGatewayError: ListReceiptFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListReceiptFilesError_7.GatewayTimeoutError,
        GenericError: ListReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceipts: {
        InvalidParameterError: ListReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListReceiptsError_3.UnauthorizedError,
        InternalServerError: ListReceiptsError_4.InternalServerError,
        BadGatewayError: ListReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListReceiptsError_6.GatewayTimeoutError,
        GenericError: ListReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceiverTransfers: {
        InvalidParameterError: ListReceiverTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListReceiverTransfersError_3.UnauthorizedError,
        NotFoundError: ListReceiverTransfersError_4.NotFoundError,
        InternalServerError: ListReceiverTransfersError_5.InternalServerError,
        BadGatewayError: ListReceiverTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListReceiverTransfersError_7.GatewayTimeoutError,
        GenericError: ListReceiverTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListSenderTransfers: {
        InvalidParameterError: ListSenderTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListSenderTransfersError_3.UnauthorizedError,
        InternalServerError: ListSenderTransfersError_4.InternalServerError,
        BadGatewayError: ListSenderTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListSenderTransfersError_6.GatewayTimeoutError,
        GenericError: ListSenderTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamDropboxes: {
        InvalidParameterError: ListTeamDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamDropboxesError_3.UnauthorizedError,
        InternalServerError: ListTeamDropboxesError_4.InternalServerError,
        BadGatewayError: ListTeamDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamDropboxesError_6.GatewayTimeoutError,
        GenericError: ListTeamDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamReceiptFiles: {
        InvalidParameterError: ListTeamReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamReceiptFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamReceiptFilesError_4.ForbiddenError,
        NotFoundError: ListTeamReceiptFilesError_5.NotFoundError,
        InternalServerError: ListTeamReceiptFilesError_6.InternalServerError,
        BadGatewayError: ListTeamReceiptFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamReceiptFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamReceipts: {
        InvalidParameterError: ListTeamReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamReceiptsError_3.UnauthorizedError,
        InternalServerError: ListTeamReceiptsError_4.InternalServerError,
        BadGatewayError: ListTeamReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamReceiptsError_6.GatewayTimeoutError,
        GenericError: ListTeamReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransferEvents: {
        InvalidParameterError: ListTeamTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListTeamTransferEventsError_4.NotFoundError,
        InternalServerError: ListTeamTransferEventsError_5.InternalServerError,
        BadGatewayError: ListTeamTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListTeamTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListTeamTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransferFiles: {
        InvalidParameterError: ListTeamTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransferFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamTransferFilesError_4.ForbiddenError,
        NotFoundError: ListTeamTransferFilesError_5.NotFoundError,
        InternalServerError: ListTeamTransferFilesError_6.InternalServerError,
        BadGatewayError: ListTeamTransferFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamTransferFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransfers: {
        InvalidParameterError: ListTeamTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransfersError_3.UnauthorizedError,
        ForbiddenError: ListTeamTransfersError_4.ForbiddenError,
        NotFoundError: ListTeamTransfersError_5.NotFoundError,
        InternalServerError: ListTeamTransfersError_6.InternalServerError,
        BadGatewayError: ListTeamTransfersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamTransfersError_8.GatewayTimeoutError,
        GenericError: ListTeamTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserDropboxes: {
        InvalidParameterError: ListTeamUserDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserDropboxesError_3.UnauthorizedError,
        InternalServerError: ListTeamUserDropboxesError_4.InternalServerError,
        BadGatewayError: ListTeamUserDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserDropboxesError_6.GatewayTimeoutError,
        GenericError: ListTeamUserDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserReceiptFiles: {
        InvalidParameterError: ListTeamUserReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserReceiptFilesError_4.ForbiddenError,
        NotFoundError: ListTeamUserReceiptFilesError_5.NotFoundError,
        InternalServerError: ListTeamUserReceiptFilesError_6.InternalServerError,
        BadGatewayError: ListTeamUserReceiptFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamUserReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserReceipts: {
        InvalidParameterError: ListTeamUserReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptsError_3.UnauthorizedError,
        InternalServerError: ListTeamUserReceiptsError_4.InternalServerError,
        BadGatewayError: ListTeamUserReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptsError_6.GatewayTimeoutError,
        GenericError: ListTeamUserReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserTransfers: {
        InvalidParameterError: ListTeamUserTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserTransfersError_3.UnauthorizedError,
        InternalServerError: ListTeamUserTransfersError_4.InternalServerError,
        BadGatewayError: ListTeamUserTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserTransfersError_6.GatewayTimeoutError,
        GenericError: ListTeamUserTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferEvents: {
        InvalidParameterError: ListTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListTransferEventsError_4.NotFoundError,
        InternalServerError: ListTransferEventsError_5.InternalServerError,
        BadGatewayError: ListTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFiles: {
        InvalidParameterError: ListTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesError_3.UnauthorizedError,
        NotFoundError: ListTransferFilesError_4.NotFoundError,
        InternalServerError: ListTransferFilesError_5.InternalServerError,
        BadGatewayError: ListTransferFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesError_7.GatewayTimeoutError,
        GenericError: ListTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFilesInternal: {
        InvalidParameterError: ListTransferFilesInternalError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesInternalError_3.UnauthorizedError,
        NotFoundError: ListTransferFilesInternalError_4.NotFoundError,
        InternalServerError: ListTransferFilesInternalError_5.InternalServerError,
        BadGatewayError: ListTransferFilesInternalError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesInternalError_7.GatewayTimeoutError,
        GenericError: ListTransferFilesInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFilesPreview: {
        InvalidParameterError: ListTransferFilesPreviewError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: ListTransferFilesPreviewError_4.PasswordDoesNotMatchError,
        OwnerUsageExceededError: ListTransferFilesPreviewError_5.OwnerUsageExceededError,
        AccessorUsageExceededError: ListTransferFilesPreviewError_6.AccessorUsageExceededError,
        NotFoundError: ListTransferFilesPreviewError_7.NotFoundError,
        InternalServerError: ListTransferFilesPreviewError_8.InternalServerError,
        BadGatewayError: ListTransferFilesPreviewError_9.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesPreviewError_10.GatewayTimeoutError,
        GenericError: ListTransferFilesPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransfers: {
        InvalidParameterError: ListTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTransfersError_3.UnauthorizedError,
        NotFoundError: ListTransfersError_4.NotFoundError,
        InternalServerError: ListTransfersError_5.InternalServerError,
        BadGatewayError: ListTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListTransfersError_7.GatewayTimeoutError,
        GenericError: ListTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserDropboxes: {
        InvalidParameterError: ListUserDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListUserDropboxesError_3.UnauthorizedError,
        InternalServerError: ListUserDropboxesError_4.InternalServerError,
        BadGatewayError: ListUserDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListUserDropboxesError_6.GatewayTimeoutError,
        GenericError: ListUserDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserReceiptFiles: {
        InvalidParameterError: ListUserReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListUserReceiptFilesError_3.UnauthorizedError,
        NotFoundError: ListUserReceiptFilesError_4.NotFoundError,
        InternalServerError: ListUserReceiptFilesError_5.InternalServerError,
        BadGatewayError: ListUserReceiptFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListUserReceiptFilesError_7.GatewayTimeoutError,
        GenericError: ListUserReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserReceipts: {
        InvalidParameterError: ListUserReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListUserReceiptsError_3.UnauthorizedError,
        InternalServerError: ListUserReceiptsError_4.InternalServerError,
        BadGatewayError: ListUserReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListUserReceiptsError_6.GatewayTimeoutError,
        GenericError: ListUserReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransferEvents: {
        InvalidParameterError: ListUserTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListUserTransferEventsError_4.NotFoundError,
        InternalServerError: ListUserTransferEventsError_5.InternalServerError,
        BadGatewayError: ListUserTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListUserTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransferFiles: {
        InvalidParameterError: ListUserTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransferFilesError_3.UnauthorizedError,
        NotFoundError: ListUserTransferFilesError_4.NotFoundError,
        InternalServerError: ListUserTransferFilesError_5.InternalServerError,
        BadGatewayError: ListUserTransferFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransferFilesError_7.GatewayTimeoutError,
        GenericError: ListUserTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransfers: {
        InvalidParameterError: ListUserTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransfersError_3.UnauthorizedError,
        NotFoundError: ListUserTransfersError_4.NotFoundError,
        InternalServerError: ListUserTransfersError_5.InternalServerError,
        BadGatewayError: ListUserTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransfersError_7.GatewayTimeoutError,
        GenericError: ListUserTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearEvents: {
        InvalidParameterError: ListYearEventsError_2.InvalidParameterError,
        UnauthorizedError: ListYearEventsError_3.UnauthorizedError,
        InternalServerError: ListYearEventsError_4.InternalServerError,
        BadGatewayError: ListYearEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListYearEventsError_6.GatewayTimeoutError,
        GenericError: ListYearEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearFiles: {
        InvalidParameterError: ListYearFilesError_2.InvalidParameterError,
        UnauthorizedError: ListYearFilesError_3.UnauthorizedError,
        InternalServerError: ListYearFilesError_4.InternalServerError,
        BadGatewayError: ListYearFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListYearFilesError_6.GatewayTimeoutError,
        GenericError: ListYearFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearTransfers: {
        InvalidParameterError: ListYearTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListYearTransfersError_3.UnauthorizedError,
        InternalServerError: ListYearTransfersError_4.InternalServerError,
        BadGatewayError: ListYearTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListYearTransfersError_6.GatewayTimeoutError,
        GenericError: ListYearTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    LockTransfer: {
        InvalidParameterError: LockTransferError_2.InvalidParameterError,
        UnauthorizedError: LockTransferError_3.UnauthorizedError,
        TransferAlreadyLockedError: LockTransferError_4.TransferAlreadyLockedError,
        TransferIsDirtyError: LockTransferError_5.TransferIsDirtyError,
        TransferIsInQueueError: LockTransferError_6.TransferIsInQueueError,
        NotFoundError: LockTransferError_7.NotFoundError,
        InternalServerError: LockTransferError_8.InternalServerError,
        BadGatewayError: LockTransferError_9.BadGatewayError,
        GatewayTimeoutError: LockTransferError_10.GatewayTimeoutError,
        GenericError: LockTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDropbox: {
        InvalidParameterError: UpdateDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateDropboxError_4.NotFoundError,
        InternalServerError: UpdateDropboxError_5.InternalServerError,
        BadGatewayError: UpdateDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateManualReview: {
        InvalidParameterError: UpdateManualReviewError_2.InvalidParameterError,
        UnauthorizedError: UpdateManualReviewError_3.UnauthorizedError,
        NotFoundError: UpdateManualReviewError_4.NotFoundError,
        InternalServerError: UpdateManualReviewError_5.InternalServerError,
        BadGatewayError: UpdateManualReviewError_6.BadGatewayError,
        GatewayTimeoutError: UpdateManualReviewError_7.GatewayTimeoutError,
        GenericError: UpdateManualReviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTeamDropbox: {
        InvalidParameterError: UpdateTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateTeamDropboxError_4.NotFoundError,
        InternalServerError: UpdateTeamDropboxError_5.InternalServerError,
        BadGatewayError: UpdateTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTeamDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTeamUserDropbox: {
        InvalidParameterError: UpdateTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateTeamUserDropboxError_4.NotFoundError,
        InternalServerError: UpdateTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: UpdateTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransfer: {
        InvalidParameterError: UpdateTransferError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferError_4.TransferAlreadyLockedError,
        NotFoundError: UpdateTransferError_5.NotFoundError,
        InternalServerError: UpdateTransferError_6.InternalServerError,
        BadGatewayError: UpdateTransferError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTransferError_8.GatewayTimeoutError,
        GenericError: UpdateTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferCustomization: {
        InvalidParameterError: UpdateTransferCustomizationError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferCustomizationError_3.UnauthorizedError,
        NotFoundError: UpdateTransferCustomizationError_4.NotFoundError,
        InternalServerError: UpdateTransferCustomizationError_5.InternalServerError,
        BadGatewayError: UpdateTransferCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTransferCustomizationError_7.GatewayTimeoutError,
        GenericError: UpdateTransferCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFile: {
        InvalidParameterError: UpdateTransferFileError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFileError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFileError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFileError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFileError_6.NotFoundError,
        InternalServerError: UpdateTransferFileError_7.InternalServerError,
        BadGatewayError: UpdateTransferFileError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFileError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFilePart: {
        InvalidParameterError: UpdateTransferFilePartError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFilePartError_6.NotFoundError,
        InternalServerError: UpdateTransferFilePartError_7.InternalServerError,
        BadGatewayError: UpdateTransferFilePartError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFileParts: {
        InvalidParameterError: UpdateTransferFilePartsError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartsError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartsError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartsError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFilePartsError_6.NotFoundError,
        InternalServerError: UpdateTransferFilePartsError_7.InternalServerError,
        BadGatewayError: UpdateTransferFilePartsError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartsError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFilePartsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateUserDropbox: {
        InvalidParameterError: UpdateUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateUserDropboxError_4.NotFoundError,
        InternalServerError: UpdateUserDropboxError_5.InternalServerError,
        BadGatewayError: UpdateUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateUserDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateDropbox: {
        InvalidParameterError: CreateDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateDropboxError_4.InvalidSubscriptionError,
        InternalServerError: CreateDropboxError_5.InternalServerError,
        BadGatewayError: CreateDropboxError_6.BadGatewayError,
        GatewayTimeoutError: CreateDropboxError_7.GatewayTimeoutError,
        GenericError: CreateDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateDropboxTransfer: {
        MissingSenderError: CreateDropboxTransferError_2.MissingSenderError,
        MissingReceiversError: CreateDropboxTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateDropboxTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateDropboxTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateDropboxTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateDropboxTransferError_7.UnauthorizedError,
        PasswordDoesNotMatchError: CreateDropboxTransferError_8.PasswordDoesNotMatchError,
        InvalidSubscriptionError: CreateDropboxTransferError_9.InvalidSubscriptionError,
        EmailNotAllowedError: CreateDropboxTransferError_10.EmailNotAllowedError,
        OwnerUsageExceededError: CreateDropboxTransferError_11.OwnerUsageExceededError,
        PasswordRequiredError: CreateDropboxTransferError_12.PasswordRequiredError,
        TeamConfigurationError: CreateDropboxTransferError_13.TeamConfigurationError,
        DropboxDisabledError: CreateDropboxTransferError_14.DropboxDisabledError,
        DropboxDeletedError: CreateDropboxTransferError_15.DropboxDeletedError,
        DropboxMaxTransferCountError: CreateDropboxTransferError_16.DropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: CreateDropboxTransferError_17.DropboxMaxBytesUploadedError,
        CustomUrlAlreadyInUseError: CreateDropboxTransferError_18.CustomUrlAlreadyInUseError,
        InternalServerError: CreateDropboxTransferError_19.InternalServerError,
        BadGatewayError: CreateDropboxTransferError_20.BadGatewayError,
        GatewayTimeoutError: CreateDropboxTransferError_21.GatewayTimeoutError,
        GenericError: CreateDropboxTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamDropbox: {
        InvalidParameterError: CreateTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateTeamDropboxError_5.NotFoundError,
        InternalServerError: CreateTeamDropboxError_6.InternalServerError,
        BadGatewayError: CreateTeamDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamDropboxError_8.GatewayTimeoutError,
        GenericError: CreateTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamTransfer: {
        MissingSenderError: CreateTeamTransferError_2.MissingSenderError,
        MissingReceiversError: CreateTeamTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateTeamTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateTeamTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateTeamTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateTeamTransferError_7.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamTransferError_8.InvalidSubscriptionError,
        EmailNotAllowedError: CreateTeamTransferError_9.EmailNotAllowedError,
        UsageExceededError: CreateTeamTransferError_10.UsageExceededError,
        PasswordRequiredError: CreateTeamTransferError_11.PasswordRequiredError,
        CustomUrlAlreadyInUseError: CreateTeamTransferError_12.CustomUrlAlreadyInUseError,
        InternalServerError: CreateTeamTransferError_13.InternalServerError,
        BadGatewayError: CreateTeamTransferError_14.BadGatewayError,
        GatewayTimeoutError: CreateTeamTransferError_15.GatewayTimeoutError,
        GenericError: CreateTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamUserDropbox: {
        InvalidParameterError: CreateTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamUserDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamUserDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateTeamUserDropboxError_5.NotFoundError,
        InternalServerError: CreateTeamUserDropboxError_6.InternalServerError,
        BadGatewayError: CreateTeamUserDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamUserDropboxError_8.GatewayTimeoutError,
        GenericError: CreateTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransfer: {
        MissingSenderError: CreateTransferError_2.MissingSenderError,
        MissingReceiversError: CreateTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateTransferError_7.UnauthorizedError,
        InvalidSubscriptionError: CreateTransferError_8.InvalidSubscriptionError,
        EmailNotAllowedError: CreateTransferError_9.EmailNotAllowedError,
        UsageExceededError: CreateTransferError_10.UsageExceededError,
        PasswordRequiredError: CreateTransferError_11.PasswordRequiredError,
        EmailNotVerifiedError: CreateTransferError_12.EmailNotVerifiedError,
        CustomUrlAlreadyInUseError: CreateTransferError_13.CustomUrlAlreadyInUseError,
        InternalServerError: CreateTransferError_14.InternalServerError,
        BadGatewayError: CreateTransferError_15.BadGatewayError,
        GatewayTimeoutError: CreateTransferError_16.GatewayTimeoutError,
        GenericError: CreateTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFile: {
        InvalidParameterError: CreateTransferFileError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFileError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFileError_4.TransferAlreadyLockedError,
        TransferIsInQueueError: CreateTransferFileError_5.TransferIsInQueueError,
        NotFoundError: CreateTransferFileError_6.NotFoundError,
        ConflictError: CreateTransferFileError_7.ConflictError,
        InternalServerError: CreateTransferFileError_8.InternalServerError,
        BadGatewayError: CreateTransferFileError_9.BadGatewayError,
        GatewayTimeoutError: CreateTransferFileError_10.GatewayTimeoutError,
        GenericError: CreateTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFilePart: {
        InvalidParameterError: CreateTransferFilePartError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFilePartError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartError_5.FileAlreadyLockedError,
        NotFoundError: CreateTransferFilePartError_6.NotFoundError,
        InternalServerError: CreateTransferFilePartError_7.InternalServerError,
        BadGatewayError: CreateTransferFilePartError_8.BadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartError_9.GatewayTimeoutError,
        GenericError: CreateTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFileParts: {
        InvalidParameterError: CreateTransferFilePartsError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFilePartsError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartsError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartsError_5.FileAlreadyLockedError,
        NotFoundError: CreateTransferFilePartsError_6.NotFoundError,
        InternalServerError: CreateTransferFilePartsError_7.InternalServerError,
        BadGatewayError: CreateTransferFilePartsError_8.BadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartsError_9.GatewayTimeoutError,
        GenericError: CreateTransferFilePartsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferSignedUrls: {
        InvalidParameterError: CreateTransferSignedUrlsError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferSignedUrlsError_3.UnauthorizedError,
        PasswordDoesNotMatchError: CreateTransferSignedUrlsError_4.PasswordDoesNotMatchError,
        NotFoundError: CreateTransferSignedUrlsError_5.NotFoundError,
        InternalServerError: CreateTransferSignedUrlsError_6.InternalServerError,
        BadGatewayError: CreateTransferSignedUrlsError_7.BadGatewayError,
        GatewayTimeoutError: CreateTransferSignedUrlsError_8.GatewayTimeoutError,
        GenericError: CreateTransferSignedUrlsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateUserDropbox: {
        InvalidParameterError: CreateUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateUserDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateUserDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateUserDropboxError_5.NotFoundError,
        InternalServerError: CreateUserDropboxError_6.InternalServerError,
        BadGatewayError: CreateUserDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateUserDropboxError_8.GatewayTimeoutError,
        GenericError: CreateUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDropbox: {
        InvalidParameterError: DeleteDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteDropboxError_4.NotFoundError,
        InternalServerError: DeleteDropboxError_5.InternalServerError,
        BadGatewayError: DeleteDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteReceipt: {
        InvalidParameterError: DeleteReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteReceiptError_4.NotFoundError,
        InternalServerError: DeleteReceiptError_5.InternalServerError,
        BadGatewayError: DeleteReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteReport: {
        InvalidParameterError: DeleteReportError_2.InvalidParameterError,
        UnauthorizedError: DeleteReportError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteReportError_4.TransferNotUploadedError,
        NotFoundError: DeleteReportError_5.NotFoundError,
        InternalServerError: DeleteReportError_6.InternalServerError,
        BadGatewayError: DeleteReportError_7.BadGatewayError,
        GatewayTimeoutError: DeleteReportError_8.GatewayTimeoutError,
        GenericError: DeleteReportError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamDropbox: {
        InvalidParameterError: DeleteTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteTeamDropboxError_4.NotFoundError,
        InternalServerError: DeleteTeamDropboxError_5.InternalServerError,
        BadGatewayError: DeleteTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamReceipt: {
        InvalidParameterError: DeleteTeamReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteTeamReceiptError_4.NotFoundError,
        InternalServerError: DeleteTeamReceiptError_5.InternalServerError,
        BadGatewayError: DeleteTeamReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteTeamReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamTransfer: {
        InvalidParameterError: DeleteTeamTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteTeamTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteTeamTransferError_5.NotFoundError,
        InternalServerError: DeleteTeamTransferError_6.InternalServerError,
        BadGatewayError: DeleteTeamTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTeamTransferError_8.GatewayTimeoutError,
        GenericError: DeleteTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamUserDropbox: {
        InvalidParameterError: DeleteTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteTeamUserDropboxError_4.NotFoundError,
        InternalServerError: DeleteTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: DeleteTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamUserReceipt: {
        InvalidParameterError: DeleteTeamUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamUserReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteTeamUserReceiptError_4.NotFoundError,
        InternalServerError: DeleteTeamUserReceiptError_5.InternalServerError,
        BadGatewayError: DeleteTeamUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamUserReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteTeamUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTransfer: {
        InvalidParameterError: DeleteTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteTransferError_5.NotFoundError,
        InternalServerError: DeleteTransferError_6.InternalServerError,
        BadGatewayError: DeleteTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTransferError_8.GatewayTimeoutError,
        GenericError: DeleteTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTransferFile: {
        InvalidParameterError: DeleteTransferFileError_2.InvalidParameterError,
        UnauthorizedError: DeleteTransferFileError_3.UnauthorizedError,
        NotFoundError: DeleteTransferFileError_4.NotFoundError,
        InternalServerError: DeleteTransferFileError_5.InternalServerError,
        BadGatewayError: DeleteTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTransferFileError_7.GatewayTimeoutError,
        GenericError: DeleteTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserDropbox: {
        InvalidParameterError: DeleteUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteUserDropboxError_4.NotFoundError,
        InternalServerError: DeleteUserDropboxError_5.InternalServerError,
        BadGatewayError: DeleteUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteUserDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserReceipt: {
        InvalidParameterError: DeleteUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteUserReceiptError_4.NotFoundError,
        InternalServerError: DeleteUserReceiptError_5.InternalServerError,
        BadGatewayError: DeleteUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteUserReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserTransfer: {
        InvalidParameterError: DeleteUserTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteUserTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteUserTransferError_5.NotFoundError,
        InternalServerError: DeleteUserTransferError_6.InternalServerError,
        BadGatewayError: DeleteUserTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserTransferError_8.GatewayTimeoutError,
        GenericError: DeleteUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountMetricStatistic: {
        InvalidParameterError: GetAccountMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamMetricStatistic: {
        InvalidParameterError: GetAccountTeamMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountTeamMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountTeamMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountTeamMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountTeamMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUsage: {
        InvalidParameterError: GetAccountTeamUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountTeamUsageError_4.InternalServerError,
        BadGatewayError: GetAccountTeamUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountTeamUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUserMetricStatistic: {
        InvalidParameterError: GetAccountTeamUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUserMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountTeamUserMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountTeamUserMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountTeamUserMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountTeamUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUserUsage: {
        InvalidParameterError: GetAccountTeamUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUserUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountTeamUserUsageError_4.InternalServerError,
        BadGatewayError: GetAccountTeamUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountTeamUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTransfer: {
        InvalidParameterError: GetAccountTransferError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTransferError_3.UnauthorizedError,
        NotFoundError: GetAccountTransferError_4.NotFoundError,
        InternalServerError: GetAccountTransferError_5.InternalServerError,
        BadGatewayError: GetAccountTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTransferError_7.GatewayTimeoutError,
        GenericError: GetAccountTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUsage: {
        InvalidParameterError: GetAccountUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountUsageError_4.InternalServerError,
        BadGatewayError: GetAccountUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUserMetricStatistic: {
        InvalidParameterError: GetAccountUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUserMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountUserMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountUserMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountUserMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountUserMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUserUsage: {
        InvalidParameterError: GetAccountUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUserUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountUserUsageError_4.InternalServerError,
        BadGatewayError: GetAccountUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountUserUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDropbox: {
        InvalidParameterError: GetDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetDropboxError_3.UnauthorizedError,
        NotFoundError: GetDropboxError_4.NotFoundError,
        InternalServerError: GetDropboxError_5.InternalServerError,
        BadGatewayError: GetDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetDropboxError_7.GatewayTimeoutError,
        GenericError: GetDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDropboxPreview: {
        InvalidParameterError: GetDropboxPreviewError_2.InvalidParameterError,
        UnauthorizedError: GetDropboxPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetDropboxPreviewError_4.PasswordDoesNotMatchError,
        InvalidSubscriptionError: GetDropboxPreviewError_5.InvalidSubscriptionError,
        OwnerUsageExceededError: GetDropboxPreviewError_6.OwnerUsageExceededError,
        DropboxDisabledError: GetDropboxPreviewError_7.DropboxDisabledError,
        DropboxDeletedError: GetDropboxPreviewError_8.DropboxDeletedError,
        DropboxMaxTransferCountError: GetDropboxPreviewError_9.DropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: GetDropboxPreviewError_10.DropboxMaxBytesUploadedError,
        NotFoundError: GetDropboxPreviewError_11.NotFoundError,
        InternalServerError: GetDropboxPreviewError_12.InternalServerError,
        BadGatewayError: GetDropboxPreviewError_13.BadGatewayError,
        GatewayTimeoutError: GetDropboxPreviewError_14.GatewayTimeoutError,
        GenericError: GetDropboxPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetManualReview: {
        InvalidParameterError: GetManualReviewError_2.InvalidParameterError,
        UnauthorizedError: GetManualReviewError_3.UnauthorizedError,
        NotFoundError: GetManualReviewError_4.NotFoundError,
        InternalServerError: GetManualReviewError_5.InternalServerError,
        BadGatewayError: GetManualReviewError_6.BadGatewayError,
        GatewayTimeoutError: GetManualReviewError_7.GatewayTimeoutError,
        GenericError: GetManualReviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetMetricStatistic: {
        InvalidParameterError: GetMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReceipt: {
        InvalidParameterError: GetReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetReceiptError_3.UnauthorizedError,
        NotFoundError: GetReceiptError_4.NotFoundError,
        InternalServerError: GetReceiptError_5.InternalServerError,
        BadGatewayError: GetReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetReceiptError_7.GatewayTimeoutError,
        GenericError: GetReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReceiptFile: {
        InvalidParameterError: GetReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetReceiptFileError_3.UnauthorizedError,
        NotFoundError: GetReceiptFileError_4.NotFoundError,
        InternalServerError: GetReceiptFileError_5.InternalServerError,
        BadGatewayError: GetReceiptFileError_6.BadGatewayError,
        GatewayTimeoutError: GetReceiptFileError_7.GatewayTimeoutError,
        GenericError: GetReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReport: {
        InvalidParameterError: GetReportError_2.InvalidParameterError,
        UnauthorizedError: GetReportError_3.UnauthorizedError,
        NotFoundError: GetReportError_4.NotFoundError,
        InternalServerError: GetReportError_5.InternalServerError,
        BadGatewayError: GetReportError_6.BadGatewayError,
        GatewayTimeoutError: GetReportError_7.GatewayTimeoutError,
        GenericError: GetReportError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamDropbox: {
        InvalidParameterError: GetTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetTeamDropboxError_3.UnauthorizedError,
        NotFoundError: GetTeamDropboxError_4.NotFoundError,
        InternalServerError: GetTeamDropboxError_5.InternalServerError,
        BadGatewayError: GetTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamDropboxError_7.GatewayTimeoutError,
        GenericError: GetTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamMetricStatistic: {
        InvalidParameterError: GetTeamMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetTeamMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetTeamMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetTeamMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetTeamMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamReceipt: {
        InvalidParameterError: GetTeamReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetTeamReceiptError_3.UnauthorizedError,
        NotFoundError: GetTeamReceiptError_4.NotFoundError,
        InternalServerError: GetTeamReceiptError_5.InternalServerError,
        BadGatewayError: GetTeamReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamReceiptError_7.GatewayTimeoutError,
        GenericError: GetTeamReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamReceiptFile: {
        InvalidParameterError: GetTeamReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamReceiptFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamReceiptFileError_4.ForbiddenError,
        NotFoundError: GetTeamReceiptFileError_5.NotFoundError,
        InternalServerError: GetTeamReceiptFileError_6.InternalServerError,
        BadGatewayError: GetTeamReceiptFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamReceiptFileError_8.GatewayTimeoutError,
        GenericError: GetTeamReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransfer: {
        InvalidParameterError: GetTeamTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferError_3.UnauthorizedError,
        NotFoundError: GetTeamTransferError_4.NotFoundError,
        InternalServerError: GetTeamTransferError_5.InternalServerError,
        BadGatewayError: GetTeamTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferError_7.GatewayTimeoutError,
        GenericError: GetTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransferFile: {
        InvalidParameterError: GetTeamTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamTransferFileError_4.ForbiddenError,
        NotFoundError: GetTeamTransferFileError_5.NotFoundError,
        InternalServerError: GetTeamTransferFileError_6.InternalServerError,
        BadGatewayError: GetTeamTransferFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferFileError_8.GatewayTimeoutError,
        GenericError: GetTeamTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransferQueue: {
        InvalidParameterError: GetTeamTransferQueueError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferQueueError_3.UnauthorizedError,
        NotFoundError: GetTeamTransferQueueError_4.NotFoundError,
        InternalServerError: GetTeamTransferQueueError_5.InternalServerError,
        BadGatewayError: GetTeamTransferQueueError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferQueueError_7.GatewayTimeoutError,
        GenericError: GetTeamTransferQueueError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUsage: {
        InvalidParameterError: GetTeamUsageError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUsageError_3.UnauthorizedError,
        InternalServerError: GetTeamUsageError_4.InternalServerError,
        BadGatewayError: GetTeamUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUsageError_6.GatewayTimeoutError,
        GenericError: GetTeamUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserDropbox: {
        InvalidParameterError: GetTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: GetTeamUserDropboxError_4.NotFoundError,
        InternalServerError: GetTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: GetTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: GetTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserMetricStatistic: {
        InvalidParameterError: GetTeamUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetTeamUserMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetTeamUserMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUserMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetTeamUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserReceipt: {
        InvalidParameterError: GetTeamUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptError_3.UnauthorizedError,
        NotFoundError: GetTeamUserReceiptError_4.NotFoundError,
        InternalServerError: GetTeamUserReceiptError_5.InternalServerError,
        BadGatewayError: GetTeamUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptError_7.GatewayTimeoutError,
        GenericError: GetTeamUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserReceiptFile: {
        InvalidParameterError: GetTeamUserReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamUserReceiptFileError_4.ForbiddenError,
        NotFoundError: GetTeamUserReceiptFileError_5.NotFoundError,
        InternalServerError: GetTeamUserReceiptFileError_6.InternalServerError,
        BadGatewayError: GetTeamUserReceiptFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptFileError_8.GatewayTimeoutError,
        GenericError: GetTeamUserReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserTransfer: {
        InvalidParameterError: GetTeamUserTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserTransferError_3.UnauthorizedError,
        NotFoundError: GetTeamUserTransferError_4.NotFoundError,
        InternalServerError: GetTeamUserTransferError_5.InternalServerError,
        BadGatewayError: GetTeamUserTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserTransferError_7.GatewayTimeoutError,
        GenericError: GetTeamUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserUsage: {
        InvalidParameterError: GetTeamUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserUsageError_3.UnauthorizedError,
        InternalServerError: GetTeamUserUsageError_4.InternalServerError,
        BadGatewayError: GetTeamUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUserUsageError_6.GatewayTimeoutError,
        GenericError: GetTeamUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransfer: {
        InvalidParameterError: GetTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTransferError_3.UnauthorizedError,
        NotFoundError: GetTransferError_4.NotFoundError,
        InternalServerError: GetTransferError_5.InternalServerError,
        BadGatewayError: GetTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferError_7.GatewayTimeoutError,
        GenericError: GetTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFile: {
        InvalidParameterError: GetTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFileError_3.UnauthorizedError,
        NotFoundError: GetTransferFileError_4.NotFoundError,
        InternalServerError: GetTransferFileError_5.InternalServerError,
        BadGatewayError: GetTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferFileError_7.GatewayTimeoutError,
        GenericError: GetTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFileInternal: {
        InvalidParameterError: GetTransferFileInternalError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFileInternalError_3.UnauthorizedError,
        NotFoundError: GetTransferFileInternalError_4.NotFoundError,
        InternalServerError: GetTransferFileInternalError_5.InternalServerError,
        BadGatewayError: GetTransferFileInternalError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferFileInternalError_7.GatewayTimeoutError,
        GenericError: GetTransferFileInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFilePreview: {
        InvalidParameterError: GetTransferFilePreviewError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFilePreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetTransferFilePreviewError_4.PasswordDoesNotMatchError,
        NotFoundError: GetTransferFilePreviewError_5.NotFoundError,
        InternalServerError: GetTransferFilePreviewError_6.InternalServerError,
        BadGatewayError: GetTransferFilePreviewError_7.BadGatewayError,
        GatewayTimeoutError: GetTransferFilePreviewError_8.GatewayTimeoutError,
        GenericError: GetTransferFilePreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    Download: {
        BadRequestError: DownloadError_2.BadRequestError,
        UnauthorizedError: DownloadError_3.UnauthorizedError,
        FobiddenError: DownloadError_4.FobiddenError,
        NotFoundError: DownloadError_5.NotFoundError,
        InternalServerError: DownloadError_6.InternalServerError,
        BadGatewayError: DownloadError_7.BadGatewayError,
        GatewayTimeoutError: DownloadError_8.GatewayTimeoutError,
        GenericError: DownloadError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UploadTransferFilePart: {
        BadRequestError: UploadTransferFilePartError_2.BadRequestError,
        InternalServerError: UploadTransferFilePartError_3.InternalServerError,
        NotFoundError: UploadTransferFilePartError_4.NotFoundError,
        NoSuchUploadError: UploadTransferFilePartError_5.NoSuchUploadError,
        AccessControlListNotSupportedError: UploadTransferFilePartError_6.AccessControlListNotSupportedError,
        AccessDeniedError: UploadTransferFilePartError_7.AccessDeniedError,
        AccessPointAlreadyOwnedByYouError: UploadTransferFilePartError_8.AccessPointAlreadyOwnedByYouError,
        AccountProblemError: UploadTransferFilePartError_9.AccountProblemError,
        AllAccessDisabledError: UploadTransferFilePartError_10.AllAccessDisabledError,
        AmbiguousGrantByEmailAddressError: UploadTransferFilePartError_11.AmbiguousGrantByEmailAddressError,
        AuthorizationHeaderMalformedError: UploadTransferFilePartError_12.AuthorizationHeaderMalformedError,
        BadDigestError: UploadTransferFilePartError_13.BadDigestError,
        EntityTooSmallError: UploadTransferFilePartError_14.EntityTooSmallError,
        EntityTooLargeError: UploadTransferFilePartError_15.EntityTooLargeError,
        ExpiredTokenError: UploadTransferFilePartError_16.ExpiredTokenError,
        IllegalLocationConstraintExceptionError: UploadTransferFilePartError_17.IllegalLocationConstraintExceptionError,
        IllegalVersioningConfigurationExceptionError: UploadTransferFilePartError_18.IllegalVersioningConfigurationExceptionError,
        IncompleteBodyError: UploadTransferFilePartError_19.IncompleteBodyError,
        InlineDataTooLargeError: UploadTransferFilePartError_20.InlineDataTooLargeError,
        InternalError: UploadTransferFilePartError_21.InternalError,
        InvalidAccessKeyIdError: UploadTransferFilePartError_22.InvalidAccessKeyIdError,
        InvalidArgumentError: UploadTransferFilePartError_23.InvalidArgumentError,
        InvalidBucketNameError: UploadTransferFilePartError_24.InvalidBucketNameError,
        InvalidBucketStateError: UploadTransferFilePartError_25.InvalidBucketStateError,
        InvalidDigestError: UploadTransferFilePartError_26.InvalidDigestError,
        InvalidLocationConstraintError: UploadTransferFilePartError_27.InvalidLocationConstraintError,
        InvalidObjectStateError: UploadTransferFilePartError_28.InvalidObjectStateError,
        InvalidPartError: UploadTransferFilePartError_29.InvalidPartError,
        InvalidPartOrderError: UploadTransferFilePartError_30.InvalidPartOrderError,
        InvalidPayerError: UploadTransferFilePartError_31.InvalidPayerError,
        InvalidPolicyDocumentError: UploadTransferFilePartError_32.InvalidPolicyDocumentError,
        InvalidRangeError: UploadTransferFilePartError_33.InvalidRangeError,
        InvalidRequestError: UploadTransferFilePartError_34.InvalidRequestError,
        InvalidSecurityError: UploadTransferFilePartError_35.InvalidSecurityError,
        InvalidTokenError: UploadTransferFilePartError_36.InvalidTokenError,
        InvalidURIError: UploadTransferFilePartError_37.InvalidURIError,
        KeyTooLongError: UploadTransferFilePartError_38.KeyTooLongError,
        MaxMessageLengthExceededError: UploadTransferFilePartError_39.MaxMessageLengthExceededError,
        MetadataTooLargeError: UploadTransferFilePartError_40.MetadataTooLargeError,
        MissingContentLengthError: UploadTransferFilePartError_41.MissingContentLengthError,
        MissingRequestBodyError: UploadTransferFilePartError_42.MissingRequestBodyError,
        MissingSecurityHeaderError: UploadTransferFilePartError_43.MissingSecurityHeaderError,
        NoSuchBucketError: UploadTransferFilePartError_44.NoSuchBucketError,
        NoSuchBucketPolicyError: UploadTransferFilePartError_45.NoSuchBucketPolicyError,
        NoSuchCORSConfigurationError: UploadTransferFilePartError_46.NoSuchCORSConfigurationError,
        NoSuchKeyError: UploadTransferFilePartError_47.NoSuchKeyError,
        NotImplementedError: UploadTransferFilePartError_48.NotImplementedError,
        RequestHeaderSectionTooLargeError: UploadTransferFilePartError_49.RequestHeaderSectionTooLargeError,
        RequestTimeoutError: UploadTransferFilePartError_50.RequestTimeoutError,
        RequestTimeTooSkewedError: UploadTransferFilePartError_51.RequestTimeTooSkewedError,
        ServerSideEncryptionConfigurationNotFoundError: UploadTransferFilePartError_52.ServerSideEncryptionConfigurationNotFoundError,
        ServiceUnavailableError: UploadTransferFilePartError_53.ServiceUnavailableError,
        SignatureDoesNotMatchError: UploadTransferFilePartError_54.SignatureDoesNotMatchError,
        SlowDownError: UploadTransferFilePartError_55.SlowDownError,
        TokenRefreshRequiredError: UploadTransferFilePartError_56.TokenRefreshRequiredError,
        UnexpectedContentError: UploadTransferFilePartError_57.UnexpectedContentError,
        UserKeyMustBeSpecifiedError: UploadTransferFilePartError_58.UserKeyMustBeSpecifiedError,
        EtagIsMissingError: UploadTransferFilePartError_59.EtagIsMissingError,
        GenericError: UploadTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferInternalError: {
        InvalidParameterError: GetTransferInternalError_2.InvalidParameterError,
        UnauthorizedError: GetTransferInternalError_3.UnauthorizedError,
        NotFoundError: GetTransferInternalError_4.NotFoundError,
        InternalServerError: GetTransferInternalError_5.InternalServerError,
        BadGatewayError: GetTransferInternalError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferInternalError_7.GatewayTimeoutError,
        GenericError: GetTransferInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferPreviewError: {
        InvalidParameterError: GetTransferPreviewError_2.InvalidParameterError,
        UnauthorizedError: GetTransferPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetTransferPreviewError_4.PasswordDoesNotMatchError,
        InvalidEmailError: GetTransferPreviewError_5.InvalidEmailError,
        OwnerUsageExceededError: GetTransferPreviewError_6.OwnerUsageExceededError,
        AccessorUsageExceededError: GetTransferPreviewError_7.AccessorUsageExceededError,
        NotFoundError: GetTransferPreviewError_8.NotFoundError,
        InternalServerError: GetTransferPreviewError_9.InternalServerError,
        BadGatewayError: GetTransferPreviewError_10.BadGatewayError,
        GatewayTimeoutError: GetTransferPreviewError_11.GatewayTimeoutError,
        GenericError: GetTransferPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferQueueError: {
        InvalidParameterError: GetTransferQueueError_2.InvalidParameterError,
        UnauthorizedError: GetTransferQueueError_3.UnauthorizedError,
        NotFoundError: GetTransferQueueError_4.NotFoundError,
        InternalServerError: GetTransferQueueError_5.InternalServerError,
        BadGatewayError: GetTransferQueueError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferQueueError_7.GatewayTimeoutError,
        GenericError: GetTransferQueueError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferUserError: {
        InvalidParameterError: GetTransferUserError_2.InvalidParameterError,
        UnauthorizedError: GetTransferUserError_3.UnauthorizedError,
        NotFoundError: GetTransferUserError_4.NotFoundError,
        InternalServerError: GetTransferUserError_5.InternalServerError,
        BadGatewayError: GetTransferUserError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferUserError_7.GatewayTimeoutError,
        GenericError: GetTransferUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUsageError: {
        UnauthorizedError: GetUsageError_2.UnauthorizedError,
        InternalServerError: GetUsageError_3.InternalServerError,
        BadGatewayError: GetUsageError_4.BadGatewayError,
        GatewayTimeoutError: GetUsageError_5.GatewayTimeoutError,
        GenericError: GetUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserDropboxError: {
        InvalidParameterError: GetUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetUserDropboxError_3.UnauthorizedError,
        NotFoundError: GetUserDropboxError_4.NotFoundError,
        InternalServerError: GetUserDropboxError_5.InternalServerError,
        BadGatewayError: GetUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetUserDropboxError_7.GatewayTimeoutError,
        GenericError: GetUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserMetricStatisticError: {
        InvalidParameterError: GetUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetUserMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetUserMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetUserMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetUserMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserReceiptError: {
        InvalidParameterError: GetUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetUserReceiptError_3.UnauthorizedError,
        NotFoundError: GetUserReceiptError_4.NotFoundError,
        InternalServerError: GetUserReceiptError_5.InternalServerError,
        BadGatewayError: GetUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetUserReceiptError_7.GatewayTimeoutError,
        GenericError: GetUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserReceiptFileError: {
        InvalidParameterError: GetUserReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetUserReceiptFileError_3.UnauthorizedError,
        NotFoundError: GetUserReceiptFileError_4.NotFoundError,
        InternalServerError: GetUserReceiptFileError_5.InternalServerError,
        BadGatewayError: GetUserReceiptFileError_6.BadGatewayError,
        GatewayTimeoutError: GetUserReceiptFileError_7.GatewayTimeoutError,
        GenericError: GetUserReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserTransferError: {
        InvalidParameterError: GetUserTransferError_2.InvalidParameterError,
        UnauthorizedError: GetUserTransferError_3.UnauthorizedError,
        NotFoundError: GetUserTransferError_4.NotFoundError,
        InternalServerError: GetUserTransferError_5.InternalServerError,
        BadGatewayError: GetUserTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetUserTransferError_7.GatewayTimeoutError,
        GenericError: GetUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserTransferFileError: {
        InvalidParameterError: GetUserTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetUserTransferFileError_3.UnauthorizedError,
        NotFoundError: GetUserTransferFileError_4.NotFoundError,
        InternalServerError: GetUserTransferFileError_5.InternalServerError,
        BadGatewayError: GetUserTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: GetUserTransferFileError_7.GatewayTimeoutError,
        GenericError: GetUserTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserUsageError: {
        InvalidParameterError: GetUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetUserUsageError_3.UnauthorizedError,
        InternalServerError: GetUserUsageError_4.InternalServerError,
        BadGatewayError: GetUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetUserUsageError_6.GatewayTimeoutError,
        GenericError: GetUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListAccountTransfersError: {
        InvalidParameterError: ListAccountTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListAccountTransfersError_3.UnauthorizedError,
        InternalServerError: ListAccountTransfersError_4.InternalServerError,
        BadGatewayError: ListAccountTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListAccountTransfersError_6.GatewayTimeoutError,
        GenericError: ListAccountTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayEventsError: {
        InvalidParameterError: ListDayEventsError_2.InvalidParameterError,
        UnauthorizedError: ListDayEventsError_3.UnauthorizedError,
        InternalServerError: ListDayEventsError_4.InternalServerError,
        BadGatewayError: ListDayEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListDayEventsError_6.GatewayTimeoutError,
        GenericError: ListDayEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayFilesError: {
        InvalidParameterError: ListDayFilesError_2.InvalidParameterError,
        UnauthorizedError: ListDayFilesError_3.UnauthorizedError,
        InternalServerError: ListDayFilesError_4.InternalServerError,
        BadGatewayError: ListDayFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListDayFilesError_6.GatewayTimeoutError,
        GenericError: ListDayFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDayTransfersError: {
        InvalidParameterError: ListDayTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListDayTransfersError_3.UnauthorizedError,
        InternalServerError: ListDayTransfersError_4.InternalServerError,
        BadGatewayError: ListDayTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListDayTransfersError_6.GatewayTimeoutError,
        GenericError: ListDayTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListDropboxesError: {
        InvalidParameterError: ListDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListDropboxesError_3.UnauthorizedError,
        InternalServerError: ListDropboxesError_4.InternalServerError,
        BadGatewayError: ListDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListDropboxesError_6.GatewayTimeoutError,
        GenericError: ListDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourEventsError: {
        InvalidParameterError: ListHourEventsError_2.InvalidParameterError,
        UnauthorizedError: ListHourEventsError_3.UnauthorizedError,
        InternalServerError: ListHourEventsError_4.InternalServerError,
        BadGatewayError: ListHourEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListHourEventsError_6.GatewayTimeoutError,
        GenericError: ListHourEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourFilesError: {
        InvalidParameterError: ListHourFilesError_2.InvalidParameterError,
        UnauthorizedError: ListHourFilesError_3.UnauthorizedError,
        InternalServerError: ListHourFilesError_4.InternalServerError,
        BadGatewayError: ListHourFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListHourFilesError_6.GatewayTimeoutError,
        GenericError: ListHourFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListHourTransfersError: {
        InvalidParameterError: ListHourTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListHourTransfersError_3.UnauthorizedError,
        InternalServerError: ListHourTransfersError_4.InternalServerError,
        BadGatewayError: ListHourTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListHourTransfersError_6.GatewayTimeoutError,
        GenericError: ListHourTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListManualReviewsError: {
        UnauthorizedError: ListManualReviewsError_2.UnauthorizedError,
        InternalServerError: ListManualReviewsError_3.InternalServerError,
        BadGatewayError: ListManualReviewsError_4.BadGatewayError,
        GatewayTimeoutError: ListManualReviewsError_5.GatewayTimeoutError,
        GenericError: ListManualReviewsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthEventsError: {
        InvalidParameterError: ListMonthEventsError_2.InvalidParameterError,
        UnauthorizedError: ListMonthEventsError_3.UnauthorizedError,
        InternalServerError: ListMonthEventsError_4.InternalServerError,
        BadGatewayError: ListMonthEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthEventsError_6.GatewayTimeoutError,
        GenericError: ListMonthEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthFilesError: {
        InvalidParameterError: ListMonthFilesError_2.InvalidParameterError,
        UnauthorizedError: ListMonthFilesError_3.UnauthorizedError,
        InternalServerError: ListMonthFilesError_4.InternalServerError,
        BadGatewayError: ListMonthFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthFilesError_6.GatewayTimeoutError,
        GenericError: ListMonthFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListMonthTransfersError: {
        InvalidParameterError: ListMonthTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListMonthTransfersError_3.UnauthorizedError,
        InternalServerError: ListMonthTransfersError_4.InternalServerError,
        BadGatewayError: ListMonthTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListMonthTransfersError_6.GatewayTimeoutError,
        GenericError: ListMonthTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceiptFilesError: {
        InvalidParameterError: ListReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListReceiptFilesError_3.UnauthorizedError,
        NotFoundError: ListReceiptFilesError_4.NotFoundError,
        InternalServerError: ListReceiptFilesError_5.InternalServerError,
        BadGatewayError: ListReceiptFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListReceiptFilesError_7.GatewayTimeoutError,
        GenericError: ListReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceiptsError: {
        InvalidParameterError: ListReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListReceiptsError_3.UnauthorizedError,
        InternalServerError: ListReceiptsError_4.InternalServerError,
        BadGatewayError: ListReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListReceiptsError_6.GatewayTimeoutError,
        GenericError: ListReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListReceiverTransfersError: {
        InvalidParameterError: ListReceiverTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListReceiverTransfersError_3.UnauthorizedError,
        NotFoundError: ListReceiverTransfersError_4.NotFoundError,
        InternalServerError: ListReceiverTransfersError_5.InternalServerError,
        BadGatewayError: ListReceiverTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListReceiverTransfersError_7.GatewayTimeoutError,
        GenericError: ListReceiverTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListSenderTransfersError: {
        InvalidParameterError: ListSenderTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListSenderTransfersError_3.UnauthorizedError,
        InternalServerError: ListSenderTransfersError_4.InternalServerError,
        BadGatewayError: ListSenderTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListSenderTransfersError_6.GatewayTimeoutError,
        GenericError: ListSenderTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamDropboxesError: {
        InvalidParameterError: ListTeamDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamDropboxesError_3.UnauthorizedError,
        InternalServerError: ListTeamDropboxesError_4.InternalServerError,
        BadGatewayError: ListTeamDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamDropboxesError_6.GatewayTimeoutError,
        GenericError: ListTeamDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamReceiptFilesError: {
        InvalidParameterError: ListTeamReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamReceiptFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamReceiptFilesError_4.ForbiddenError,
        NotFoundError: ListTeamReceiptFilesError_5.NotFoundError,
        InternalServerError: ListTeamReceiptFilesError_6.InternalServerError,
        BadGatewayError: ListTeamReceiptFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamReceiptFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamReceiptsError: {
        InvalidParameterError: ListTeamReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamReceiptsError_3.UnauthorizedError,
        InternalServerError: ListTeamReceiptsError_4.InternalServerError,
        BadGatewayError: ListTeamReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamReceiptsError_6.GatewayTimeoutError,
        GenericError: ListTeamReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransferEventsError: {
        InvalidParameterError: ListTeamTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListTeamTransferEventsError_4.NotFoundError,
        InternalServerError: ListTeamTransferEventsError_5.InternalServerError,
        BadGatewayError: ListTeamTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListTeamTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListTeamTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransferFilesError: {
        InvalidParameterError: ListTeamTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransferFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamTransferFilesError_4.ForbiddenError,
        NotFoundError: ListTeamTransferFilesError_5.NotFoundError,
        InternalServerError: ListTeamTransferFilesError_6.InternalServerError,
        BadGatewayError: ListTeamTransferFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamTransferFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamTransfersError: {
        InvalidParameterError: ListTeamTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamTransfersError_3.UnauthorizedError,
        ForbiddenError: ListTeamTransfersError_4.ForbiddenError,
        NotFoundError: ListTeamTransfersError_5.NotFoundError,
        InternalServerError: ListTeamTransfersError_6.InternalServerError,
        BadGatewayError: ListTeamTransfersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamTransfersError_8.GatewayTimeoutError,
        GenericError: ListTeamTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserDropboxesError: {
        InvalidParameterError: ListTeamUserDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserDropboxesError_3.UnauthorizedError,
        InternalServerError: ListTeamUserDropboxesError_4.InternalServerError,
        BadGatewayError: ListTeamUserDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserDropboxesError_6.GatewayTimeoutError,
        GenericError: ListTeamUserDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserReceiptFilesError: {
        InvalidParameterError: ListTeamUserReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptFilesError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserReceiptFilesError_4.ForbiddenError,
        NotFoundError: ListTeamUserReceiptFilesError_5.NotFoundError,
        InternalServerError: ListTeamUserReceiptFilesError_6.InternalServerError,
        BadGatewayError: ListTeamUserReceiptFilesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptFilesError_8.GatewayTimeoutError,
        GenericError: ListTeamUserReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserReceiptsError: {
        InvalidParameterError: ListTeamUserReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptsError_3.UnauthorizedError,
        InternalServerError: ListTeamUserReceiptsError_4.InternalServerError,
        BadGatewayError: ListTeamUserReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptsError_6.GatewayTimeoutError,
        GenericError: ListTeamUserReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamUserTransfersError: {
        InvalidParameterError: ListTeamUserTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserTransfersError_3.UnauthorizedError,
        InternalServerError: ListTeamUserTransfersError_4.InternalServerError,
        BadGatewayError: ListTeamUserTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamUserTransfersError_6.GatewayTimeoutError,
        GenericError: ListTeamUserTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferEventsError: {
        InvalidParameterError: ListTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListTransferEventsError_4.NotFoundError,
        InternalServerError: ListTransferEventsError_5.InternalServerError,
        BadGatewayError: ListTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFilesError: {
        InvalidParameterError: ListTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesError_3.UnauthorizedError,
        NotFoundError: ListTransferFilesError_4.NotFoundError,
        InternalServerError: ListTransferFilesError_5.InternalServerError,
        BadGatewayError: ListTransferFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesError_7.GatewayTimeoutError,
        GenericError: ListTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFilesInternalError: {
        InvalidParameterError: ListTransferFilesInternalError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesInternalError_3.UnauthorizedError,
        NotFoundError: ListTransferFilesInternalError_4.NotFoundError,
        InternalServerError: ListTransferFilesInternalError_5.InternalServerError,
        BadGatewayError: ListTransferFilesInternalError_6.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesInternalError_7.GatewayTimeoutError,
        GenericError: ListTransferFilesInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransferFilesPreviewError: {
        InvalidParameterError: ListTransferFilesPreviewError_2.InvalidParameterError,
        UnauthorizedError: ListTransferFilesPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: ListTransferFilesPreviewError_4.PasswordDoesNotMatchError,
        OwnerUsageExceededError: ListTransferFilesPreviewError_5.OwnerUsageExceededError,
        AccessorUsageExceededError: ListTransferFilesPreviewError_6.AccessorUsageExceededError,
        NotFoundError: ListTransferFilesPreviewError_7.NotFoundError,
        InternalServerError: ListTransferFilesPreviewError_8.InternalServerError,
        BadGatewayError: ListTransferFilesPreviewError_9.BadGatewayError,
        GatewayTimeoutError: ListTransferFilesPreviewError_10.GatewayTimeoutError,
        GenericError: ListTransferFilesPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTransfersError: {
        InvalidParameterError: ListTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListTransfersError_3.UnauthorizedError,
        NotFoundError: ListTransfersError_4.NotFoundError,
        InternalServerError: ListTransfersError_5.InternalServerError,
        BadGatewayError: ListTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListTransfersError_7.GatewayTimeoutError,
        GenericError: ListTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserDropboxesError: {
        InvalidParameterError: ListUserDropboxesError_2.InvalidParameterError,
        UnauthorizedError: ListUserDropboxesError_3.UnauthorizedError,
        InternalServerError: ListUserDropboxesError_4.InternalServerError,
        BadGatewayError: ListUserDropboxesError_5.BadGatewayError,
        GatewayTimeoutError: ListUserDropboxesError_6.GatewayTimeoutError,
        GenericError: ListUserDropboxesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserReceiptFilesError: {
        InvalidParameterError: ListUserReceiptFilesError_2.InvalidParameterError,
        UnauthorizedError: ListUserReceiptFilesError_3.UnauthorizedError,
        NotFoundError: ListUserReceiptFilesError_4.NotFoundError,
        InternalServerError: ListUserReceiptFilesError_5.InternalServerError,
        BadGatewayError: ListUserReceiptFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListUserReceiptFilesError_7.GatewayTimeoutError,
        GenericError: ListUserReceiptFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserReceiptsError: {
        InvalidParameterError: ListUserReceiptsError_2.InvalidParameterError,
        UnauthorizedError: ListUserReceiptsError_3.UnauthorizedError,
        InternalServerError: ListUserReceiptsError_4.InternalServerError,
        BadGatewayError: ListUserReceiptsError_5.BadGatewayError,
        GatewayTimeoutError: ListUserReceiptsError_6.GatewayTimeoutError,
        GenericError: ListUserReceiptsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransferEventsError: {
        InvalidParameterError: ListUserTransferEventsError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransferEventsError_3.UnauthorizedError,
        NotFoundError: ListUserTransferEventsError_4.NotFoundError,
        InternalServerError: ListUserTransferEventsError_5.InternalServerError,
        BadGatewayError: ListUserTransferEventsError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransferEventsError_7.GatewayTimeoutError,
        GenericError: ListUserTransferEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransferFilesError: {
        InvalidParameterError: ListUserTransferFilesError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransferFilesError_3.UnauthorizedError,
        NotFoundError: ListUserTransferFilesError_4.NotFoundError,
        InternalServerError: ListUserTransferFilesError_5.InternalServerError,
        BadGatewayError: ListUserTransferFilesError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransferFilesError_7.GatewayTimeoutError,
        GenericError: ListUserTransferFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserTransfersError: {
        InvalidParameterError: ListUserTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListUserTransfersError_3.UnauthorizedError,
        NotFoundError: ListUserTransfersError_4.NotFoundError,
        InternalServerError: ListUserTransfersError_5.InternalServerError,
        BadGatewayError: ListUserTransfersError_6.BadGatewayError,
        GatewayTimeoutError: ListUserTransfersError_7.GatewayTimeoutError,
        GenericError: ListUserTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearEventsError: {
        InvalidParameterError: ListYearEventsError_2.InvalidParameterError,
        UnauthorizedError: ListYearEventsError_3.UnauthorizedError,
        InternalServerError: ListYearEventsError_4.InternalServerError,
        BadGatewayError: ListYearEventsError_5.BadGatewayError,
        GatewayTimeoutError: ListYearEventsError_6.GatewayTimeoutError,
        GenericError: ListYearEventsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearFilesError: {
        InvalidParameterError: ListYearFilesError_2.InvalidParameterError,
        UnauthorizedError: ListYearFilesError_3.UnauthorizedError,
        InternalServerError: ListYearFilesError_4.InternalServerError,
        BadGatewayError: ListYearFilesError_5.BadGatewayError,
        GatewayTimeoutError: ListYearFilesError_6.GatewayTimeoutError,
        GenericError: ListYearFilesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListYearTransfersError: {
        InvalidParameterError: ListYearTransfersError_2.InvalidParameterError,
        UnauthorizedError: ListYearTransfersError_3.UnauthorizedError,
        InternalServerError: ListYearTransfersError_4.InternalServerError,
        BadGatewayError: ListYearTransfersError_5.BadGatewayError,
        GatewayTimeoutError: ListYearTransfersError_6.GatewayTimeoutError,
        GenericError: ListYearTransfersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    LockTransferError: {
        InvalidParameterError: LockTransferError_2.InvalidParameterError,
        UnauthorizedError: LockTransferError_3.UnauthorizedError,
        TransferAlreadyLockedError: LockTransferError_4.TransferAlreadyLockedError,
        TransferIsDirtyError: LockTransferError_5.TransferIsDirtyError,
        TransferIsInQueueError: LockTransferError_6.TransferIsInQueueError,
        NotFoundError: LockTransferError_7.NotFoundError,
        InternalServerError: LockTransferError_8.InternalServerError,
        BadGatewayError: LockTransferError_9.BadGatewayError,
        GatewayTimeoutError: LockTransferError_10.GatewayTimeoutError,
        GenericError: LockTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateDropboxError: {
        InvalidParameterError: UpdateDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateDropboxError_4.NotFoundError,
        InternalServerError: UpdateDropboxError_5.InternalServerError,
        BadGatewayError: UpdateDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateManualReviewError: {
        InvalidParameterError: UpdateManualReviewError_2.InvalidParameterError,
        UnauthorizedError: UpdateManualReviewError_3.UnauthorizedError,
        NotFoundError: UpdateManualReviewError_4.NotFoundError,
        InternalServerError: UpdateManualReviewError_5.InternalServerError,
        BadGatewayError: UpdateManualReviewError_6.BadGatewayError,
        GatewayTimeoutError: UpdateManualReviewError_7.GatewayTimeoutError,
        GenericError: UpdateManualReviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTeamDropboxError: {
        InvalidParameterError: UpdateTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateTeamDropboxError_4.NotFoundError,
        InternalServerError: UpdateTeamDropboxError_5.InternalServerError,
        BadGatewayError: UpdateTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTeamDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTeamUserDropboxError: {
        InvalidParameterError: UpdateTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateTeamUserDropboxError_4.NotFoundError,
        InternalServerError: UpdateTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: UpdateTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferError: {
        InvalidParameterError: UpdateTransferError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferError_4.TransferAlreadyLockedError,
        NotFoundError: UpdateTransferError_5.NotFoundError,
        InternalServerError: UpdateTransferError_6.InternalServerError,
        BadGatewayError: UpdateTransferError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTransferError_8.GatewayTimeoutError,
        GenericError: UpdateTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferCustomizationError: {
        InvalidParameterError: UpdateTransferCustomizationError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferCustomizationError_3.UnauthorizedError,
        NotFoundError: UpdateTransferCustomizationError_4.NotFoundError,
        InternalServerError: UpdateTransferCustomizationError_5.InternalServerError,
        BadGatewayError: UpdateTransferCustomizationError_6.BadGatewayError,
        GatewayTimeoutError: UpdateTransferCustomizationError_7.GatewayTimeoutError,
        GenericError: UpdateTransferCustomizationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFileError: {
        InvalidParameterError: UpdateTransferFileError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFileError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFileError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFileError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFileError_6.NotFoundError,
        InternalServerError: UpdateTransferFileError_7.InternalServerError,
        BadGatewayError: UpdateTransferFileError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFileError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFilePartError: {
        InvalidParameterError: UpdateTransferFilePartError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFilePartError_6.NotFoundError,
        InternalServerError: UpdateTransferFilePartError_7.InternalServerError,
        BadGatewayError: UpdateTransferFilePartError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateTransferFilePartsError: {
        InvalidParameterError: UpdateTransferFilePartsError_2.InvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartsError_3.UnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartsError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartsError_5.FileAlreadyLockedError,
        NotFoundError: UpdateTransferFilePartsError_6.NotFoundError,
        InternalServerError: UpdateTransferFilePartsError_7.InternalServerError,
        BadGatewayError: UpdateTransferFilePartsError_8.BadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartsError_9.GatewayTimeoutError,
        GenericError: UpdateTransferFilePartsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateUserDropboxError: {
        InvalidParameterError: UpdateUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserDropboxError_3.UnauthorizedError,
        NotFoundError: UpdateUserDropboxError_4.NotFoundError,
        InternalServerError: UpdateUserDropboxError_5.InternalServerError,
        BadGatewayError: UpdateUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: UpdateUserDropboxError_7.GatewayTimeoutError,
        GenericError: UpdateUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateDropboxError: {
        InvalidParameterError: CreateDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateDropboxError_4.InvalidSubscriptionError,
        InternalServerError: CreateDropboxError_5.InternalServerError,
        BadGatewayError: CreateDropboxError_6.BadGatewayError,
        GatewayTimeoutError: CreateDropboxError_7.GatewayTimeoutError,
        GenericError: CreateDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateDropboxTransferError: {
        MissingSenderError: CreateDropboxTransferError_2.MissingSenderError,
        MissingReceiversError: CreateDropboxTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateDropboxTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateDropboxTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateDropboxTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateDropboxTransferError_7.UnauthorizedError,
        PasswordDoesNotMatchError: CreateDropboxTransferError_8.PasswordDoesNotMatchError,
        InvalidSubscriptionError: CreateDropboxTransferError_9.InvalidSubscriptionError,
        EmailNotAllowedError: CreateDropboxTransferError_10.EmailNotAllowedError,
        OwnerUsageExceededError: CreateDropboxTransferError_11.OwnerUsageExceededError,
        PasswordRequiredError: CreateDropboxTransferError_12.PasswordRequiredError,
        TeamConfigurationError: CreateDropboxTransferError_13.TeamConfigurationError,
        DropboxDisabledError: CreateDropboxTransferError_14.DropboxDisabledError,
        DropboxDeletedError: CreateDropboxTransferError_15.DropboxDeletedError,
        DropboxMaxTransferCountError: CreateDropboxTransferError_16.DropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: CreateDropboxTransferError_17.DropboxMaxBytesUploadedError,
        CustomUrlAlreadyInUseError: CreateDropboxTransferError_18.CustomUrlAlreadyInUseError,
        InternalServerError: CreateDropboxTransferError_19.InternalServerError,
        BadGatewayError: CreateDropboxTransferError_20.BadGatewayError,
        GatewayTimeoutError: CreateDropboxTransferError_21.GatewayTimeoutError,
        GenericError: CreateDropboxTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamDropboxError: {
        InvalidParameterError: CreateTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateTeamDropboxError_5.NotFoundError,
        InternalServerError: CreateTeamDropboxError_6.InternalServerError,
        BadGatewayError: CreateTeamDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamDropboxError_8.GatewayTimeoutError,
        GenericError: CreateTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamTransferError: {
        MissingSenderError: CreateTeamTransferError_2.MissingSenderError,
        MissingReceiversError: CreateTeamTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateTeamTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateTeamTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateTeamTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateTeamTransferError_7.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamTransferError_8.InvalidSubscriptionError,
        EmailNotAllowedError: CreateTeamTransferError_9.EmailNotAllowedError,
        UsageExceededError: CreateTeamTransferError_10.UsageExceededError,
        PasswordRequiredError: CreateTeamTransferError_11.PasswordRequiredError,
        CustomUrlAlreadyInUseError: CreateTeamTransferError_12.CustomUrlAlreadyInUseError,
        InternalServerError: CreateTeamTransferError_13.InternalServerError,
        BadGatewayError: CreateTeamTransferError_14.BadGatewayError,
        GatewayTimeoutError: CreateTeamTransferError_15.GatewayTimeoutError,
        GenericError: CreateTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTeamUserDropboxError: {
        InvalidParameterError: CreateTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamUserDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateTeamUserDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateTeamUserDropboxError_5.NotFoundError,
        InternalServerError: CreateTeamUserDropboxError_6.InternalServerError,
        BadGatewayError: CreateTeamUserDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamUserDropboxError_8.GatewayTimeoutError,
        GenericError: CreateTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferError: {
        MissingSenderError: CreateTransferError_2.MissingSenderError,
        MissingReceiversError: CreateTransferError_3.MissingReceiversError,
        InvalidDeliveryError: CreateTransferError_4.InvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateTransferError_5.InvalidAvailabilityDurationError,
        InvalidParameterError: CreateTransferError_6.InvalidParameterError,
        UnauthorizedError: CreateTransferError_7.UnauthorizedError,
        InvalidSubscriptionError: CreateTransferError_8.InvalidSubscriptionError,
        EmailNotAllowedError: CreateTransferError_9.EmailNotAllowedError,
        UsageExceededError: CreateTransferError_10.UsageExceededError,
        PasswordRequiredError: CreateTransferError_11.PasswordRequiredError,
        EmailNotVerifiedError: CreateTransferError_12.EmailNotVerifiedError,
        CustomUrlAlreadyInUseError: CreateTransferError_13.CustomUrlAlreadyInUseError,
        InternalServerError: CreateTransferError_14.InternalServerError,
        BadGatewayError: CreateTransferError_15.BadGatewayError,
        GatewayTimeoutError: CreateTransferError_16.GatewayTimeoutError,
        GenericError: CreateTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFileError: {
        InvalidParameterError: CreateTransferFileError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFileError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFileError_4.TransferAlreadyLockedError,
        TransferIsInQueueError: CreateTransferFileError_5.TransferIsInQueueError,
        NotFoundError: CreateTransferFileError_6.NotFoundError,
        ConflictError: CreateTransferFileError_7.ConflictError,
        InternalServerError: CreateTransferFileError_8.InternalServerError,
        BadGatewayError: CreateTransferFileError_9.BadGatewayError,
        GatewayTimeoutError: CreateTransferFileError_10.GatewayTimeoutError,
        GenericError: CreateTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFilePartError: {
        InvalidParameterError: CreateTransferFilePartError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFilePartError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartError_5.FileAlreadyLockedError,
        NotFoundError: CreateTransferFilePartError_6.NotFoundError,
        InternalServerError: CreateTransferFilePartError_7.InternalServerError,
        BadGatewayError: CreateTransferFilePartError_8.BadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartError_9.GatewayTimeoutError,
        GenericError: CreateTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferFilePartsError: {
        InvalidParameterError: CreateTransferFilePartsError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferFilePartsError_3.UnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartsError_4.TransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartsError_5.FileAlreadyLockedError,
        NotFoundError: CreateTransferFilePartsError_6.NotFoundError,
        InternalServerError: CreateTransferFilePartsError_7.InternalServerError,
        BadGatewayError: CreateTransferFilePartsError_8.BadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartsError_9.GatewayTimeoutError,
        GenericError: CreateTransferFilePartsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTransferSignedUrlsError: {
        InvalidParameterError: CreateTransferSignedUrlsError_2.InvalidParameterError,
        UnauthorizedError: CreateTransferSignedUrlsError_3.UnauthorizedError,
        PasswordDoesNotMatchError: CreateTransferSignedUrlsError_4.PasswordDoesNotMatchError,
        NotFoundError: CreateTransferSignedUrlsError_5.NotFoundError,
        InternalServerError: CreateTransferSignedUrlsError_6.InternalServerError,
        BadGatewayError: CreateTransferSignedUrlsError_7.BadGatewayError,
        GatewayTimeoutError: CreateTransferSignedUrlsError_8.GatewayTimeoutError,
        GenericError: CreateTransferSignedUrlsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateUserDropboxError: {
        InvalidParameterError: CreateUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: CreateUserDropboxError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateUserDropboxError_4.InvalidSubscriptionError,
        NotFoundError: CreateUserDropboxError_5.NotFoundError,
        InternalServerError: CreateUserDropboxError_6.InternalServerError,
        BadGatewayError: CreateUserDropboxError_7.BadGatewayError,
        GatewayTimeoutError: CreateUserDropboxError_8.GatewayTimeoutError,
        GenericError: CreateUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteDropboxError: {
        InvalidParameterError: DeleteDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteDropboxError_4.NotFoundError,
        InternalServerError: DeleteDropboxError_5.InternalServerError,
        BadGatewayError: DeleteDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteReceiptError: {
        InvalidParameterError: DeleteReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteReceiptError_4.NotFoundError,
        InternalServerError: DeleteReceiptError_5.InternalServerError,
        BadGatewayError: DeleteReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteReportError: {
        InvalidParameterError: DeleteReportError_2.InvalidParameterError,
        UnauthorizedError: DeleteReportError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteReportError_4.TransferNotUploadedError,
        NotFoundError: DeleteReportError_5.NotFoundError,
        InternalServerError: DeleteReportError_6.InternalServerError,
        BadGatewayError: DeleteReportError_7.BadGatewayError,
        GatewayTimeoutError: DeleteReportError_8.GatewayTimeoutError,
        GenericError: DeleteReportError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamDropboxError: {
        InvalidParameterError: DeleteTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteTeamDropboxError_4.NotFoundError,
        InternalServerError: DeleteTeamDropboxError_5.InternalServerError,
        BadGatewayError: DeleteTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamReceiptError: {
        InvalidParameterError: DeleteTeamReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteTeamReceiptError_4.NotFoundError,
        InternalServerError: DeleteTeamReceiptError_5.InternalServerError,
        BadGatewayError: DeleteTeamReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteTeamReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamTransferError: {
        InvalidParameterError: DeleteTeamTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteTeamTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteTeamTransferError_5.NotFoundError,
        InternalServerError: DeleteTeamTransferError_6.InternalServerError,
        BadGatewayError: DeleteTeamTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTeamTransferError_8.GatewayTimeoutError,
        GenericError: DeleteTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamUserDropboxError: {
        InvalidParameterError: DeleteTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteTeamUserDropboxError_4.NotFoundError,
        InternalServerError: DeleteTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: DeleteTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTeamUserReceiptError: {
        InvalidParameterError: DeleteTeamUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamUserReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteTeamUserReceiptError_4.NotFoundError,
        InternalServerError: DeleteTeamUserReceiptError_5.InternalServerError,
        BadGatewayError: DeleteTeamUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTeamUserReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteTeamUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTransferError: {
        InvalidParameterError: DeleteTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteTransferError_5.NotFoundError,
        InternalServerError: DeleteTransferError_6.InternalServerError,
        BadGatewayError: DeleteTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTransferError_8.GatewayTimeoutError,
        GenericError: DeleteTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteTransferFileError: {
        InvalidParameterError: DeleteTransferFileError_2.InvalidParameterError,
        UnauthorizedError: DeleteTransferFileError_3.UnauthorizedError,
        NotFoundError: DeleteTransferFileError_4.NotFoundError,
        InternalServerError: DeleteTransferFileError_5.InternalServerError,
        BadGatewayError: DeleteTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: DeleteTransferFileError_7.GatewayTimeoutError,
        GenericError: DeleteTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserDropboxError: {
        InvalidParameterError: DeleteUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserDropboxError_3.UnauthorizedError,
        NotFoundError: DeleteUserDropboxError_4.NotFoundError,
        InternalServerError: DeleteUserDropboxError_5.InternalServerError,
        BadGatewayError: DeleteUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: DeleteUserDropboxError_7.GatewayTimeoutError,
        GenericError: DeleteUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserReceiptError: {
        InvalidParameterError: DeleteUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserReceiptError_3.UnauthorizedError,
        NotFoundError: DeleteUserReceiptError_4.NotFoundError,
        InternalServerError: DeleteUserReceiptError_5.InternalServerError,
        BadGatewayError: DeleteUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: DeleteUserReceiptError_7.GatewayTimeoutError,
        GenericError: DeleteUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteUserTransferError: {
        InvalidParameterError: DeleteUserTransferError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserTransferError_3.UnauthorizedError,
        TransferNotUploadedError: DeleteUserTransferError_4.TransferNotUploadedError,
        NotFoundError: DeleteUserTransferError_5.NotFoundError,
        InternalServerError: DeleteUserTransferError_6.InternalServerError,
        BadGatewayError: DeleteUserTransferError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserTransferError_8.GatewayTimeoutError,
        GenericError: DeleteUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountMetricStatisticError: {
        InvalidParameterError: GetAccountMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamMetricStatisticError: {
        InvalidParameterError: GetAccountTeamMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountTeamMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountTeamMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountTeamMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountTeamMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUsageError: {
        InvalidParameterError: GetAccountTeamUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountTeamUsageError_4.InternalServerError,
        BadGatewayError: GetAccountTeamUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountTeamUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUserMetricStatisticError: {
        InvalidParameterError: GetAccountTeamUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUserMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountTeamUserMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountTeamUserMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountTeamUserMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountTeamUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTeamUserUsageError: {
        InvalidParameterError: GetAccountTeamUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTeamUserUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountTeamUserUsageError_4.InternalServerError,
        BadGatewayError: GetAccountTeamUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountTeamUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountTransferError: {
        InvalidParameterError: GetAccountTransferError_2.InvalidParameterError,
        UnauthorizedError: GetAccountTransferError_3.UnauthorizedError,
        NotFoundError: GetAccountTransferError_4.NotFoundError,
        InternalServerError: GetAccountTransferError_5.InternalServerError,
        BadGatewayError: GetAccountTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountTransferError_7.GatewayTimeoutError,
        GenericError: GetAccountTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUsageError: {
        InvalidParameterError: GetAccountUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountUsageError_4.InternalServerError,
        BadGatewayError: GetAccountUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUserMetricStatisticError: {
        InvalidParameterError: GetAccountUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUserMetricStatisticError_3.UnauthorizedError,
        NotFoundError: GetAccountUserMetricStatisticError_4.NotFoundError,
        InternalServerError: GetAccountUserMetricStatisticError_5.InternalServerError,
        BadGatewayError: GetAccountUserMetricStatisticError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountUserMetricStatisticError_7.GatewayTimeoutError,
        GenericError: GetAccountUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetAccountUserUsageError: {
        InvalidParameterError: GetAccountUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetAccountUserUsageError_3.UnauthorizedError,
        InternalServerError: GetAccountUserUsageError_4.InternalServerError,
        BadGatewayError: GetAccountUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetAccountUserUsageError_6.GatewayTimeoutError,
        GenericError: GetAccountUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDropboxError: {
        InvalidParameterError: GetDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetDropboxError_3.UnauthorizedError,
        NotFoundError: GetDropboxError_4.NotFoundError,
        InternalServerError: GetDropboxError_5.InternalServerError,
        BadGatewayError: GetDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetDropboxError_7.GatewayTimeoutError,
        GenericError: GetDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetDropboxPreviewError: {
        InvalidParameterError: GetDropboxPreviewError_2.InvalidParameterError,
        UnauthorizedError: GetDropboxPreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetDropboxPreviewError_4.PasswordDoesNotMatchError,
        InvalidSubscriptionError: GetDropboxPreviewError_5.InvalidSubscriptionError,
        OwnerUsageExceededError: GetDropboxPreviewError_6.OwnerUsageExceededError,
        DropboxDisabledError: GetDropboxPreviewError_7.DropboxDisabledError,
        DropboxDeletedError: GetDropboxPreviewError_8.DropboxDeletedError,
        DropboxMaxTransferCountError: GetDropboxPreviewError_9.DropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: GetDropboxPreviewError_10.DropboxMaxBytesUploadedError,
        NotFoundError: GetDropboxPreviewError_11.NotFoundError,
        InternalServerError: GetDropboxPreviewError_12.InternalServerError,
        BadGatewayError: GetDropboxPreviewError_13.BadGatewayError,
        GatewayTimeoutError: GetDropboxPreviewError_14.GatewayTimeoutError,
        GenericError: GetDropboxPreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetManualReviewError: {
        InvalidParameterError: GetManualReviewError_2.InvalidParameterError,
        UnauthorizedError: GetManualReviewError_3.UnauthorizedError,
        NotFoundError: GetManualReviewError_4.NotFoundError,
        InternalServerError: GetManualReviewError_5.InternalServerError,
        BadGatewayError: GetManualReviewError_6.BadGatewayError,
        GatewayTimeoutError: GetManualReviewError_7.GatewayTimeoutError,
        GenericError: GetManualReviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetMetricStatisticError: {
        InvalidParameterError: GetMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReceiptError: {
        InvalidParameterError: GetReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetReceiptError_3.UnauthorizedError,
        NotFoundError: GetReceiptError_4.NotFoundError,
        InternalServerError: GetReceiptError_5.InternalServerError,
        BadGatewayError: GetReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetReceiptError_7.GatewayTimeoutError,
        GenericError: GetReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReceiptFileError: {
        InvalidParameterError: GetReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetReceiptFileError_3.UnauthorizedError,
        NotFoundError: GetReceiptFileError_4.NotFoundError,
        InternalServerError: GetReceiptFileError_5.InternalServerError,
        BadGatewayError: GetReceiptFileError_6.BadGatewayError,
        GatewayTimeoutError: GetReceiptFileError_7.GatewayTimeoutError,
        GenericError: GetReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetReportError: {
        InvalidParameterError: GetReportError_2.InvalidParameterError,
        UnauthorizedError: GetReportError_3.UnauthorizedError,
        NotFoundError: GetReportError_4.NotFoundError,
        InternalServerError: GetReportError_5.InternalServerError,
        BadGatewayError: GetReportError_6.BadGatewayError,
        GatewayTimeoutError: GetReportError_7.GatewayTimeoutError,
        GenericError: GetReportError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamDropboxError: {
        InvalidParameterError: GetTeamDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetTeamDropboxError_3.UnauthorizedError,
        NotFoundError: GetTeamDropboxError_4.NotFoundError,
        InternalServerError: GetTeamDropboxError_5.InternalServerError,
        BadGatewayError: GetTeamDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamDropboxError_7.GatewayTimeoutError,
        GenericError: GetTeamDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamMetricStatisticError: {
        InvalidParameterError: GetTeamMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetTeamMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetTeamMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetTeamMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetTeamMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamReceiptError: {
        InvalidParameterError: GetTeamReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetTeamReceiptError_3.UnauthorizedError,
        NotFoundError: GetTeamReceiptError_4.NotFoundError,
        InternalServerError: GetTeamReceiptError_5.InternalServerError,
        BadGatewayError: GetTeamReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamReceiptError_7.GatewayTimeoutError,
        GenericError: GetTeamReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamReceiptFileError: {
        InvalidParameterError: GetTeamReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamReceiptFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamReceiptFileError_4.ForbiddenError,
        NotFoundError: GetTeamReceiptFileError_5.NotFoundError,
        InternalServerError: GetTeamReceiptFileError_6.InternalServerError,
        BadGatewayError: GetTeamReceiptFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamReceiptFileError_8.GatewayTimeoutError,
        GenericError: GetTeamReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransferError: {
        InvalidParameterError: GetTeamTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferError_3.UnauthorizedError,
        NotFoundError: GetTeamTransferError_4.NotFoundError,
        InternalServerError: GetTeamTransferError_5.InternalServerError,
        BadGatewayError: GetTeamTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferError_7.GatewayTimeoutError,
        GenericError: GetTeamTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransferFileError: {
        InvalidParameterError: GetTeamTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamTransferFileError_4.ForbiddenError,
        NotFoundError: GetTeamTransferFileError_5.NotFoundError,
        InternalServerError: GetTeamTransferFileError_6.InternalServerError,
        BadGatewayError: GetTeamTransferFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferFileError_8.GatewayTimeoutError,
        GenericError: GetTeamTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamTransferQueueError: {
        InvalidParameterError: GetTeamTransferQueueError_2.InvalidParameterError,
        UnauthorizedError: GetTeamTransferQueueError_3.UnauthorizedError,
        NotFoundError: GetTeamTransferQueueError_4.NotFoundError,
        InternalServerError: GetTeamTransferQueueError_5.InternalServerError,
        BadGatewayError: GetTeamTransferQueueError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamTransferQueueError_7.GatewayTimeoutError,
        GenericError: GetTeamTransferQueueError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUsageError: {
        InvalidParameterError: GetTeamUsageError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUsageError_3.UnauthorizedError,
        InternalServerError: GetTeamUsageError_4.InternalServerError,
        BadGatewayError: GetTeamUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUsageError_6.GatewayTimeoutError,
        GenericError: GetTeamUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserDropboxError: {
        InvalidParameterError: GetTeamUserDropboxError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserDropboxError_3.UnauthorizedError,
        NotFoundError: GetTeamUserDropboxError_4.NotFoundError,
        InternalServerError: GetTeamUserDropboxError_5.InternalServerError,
        BadGatewayError: GetTeamUserDropboxError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserDropboxError_7.GatewayTimeoutError,
        GenericError: GetTeamUserDropboxError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserMetricStatisticError: {
        InvalidParameterError: GetTeamUserMetricStatisticError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserMetricStatisticError_3.UnauthorizedError,
        InternalServerError: GetTeamUserMetricStatisticError_4.InternalServerError,
        BadGatewayError: GetTeamUserMetricStatisticError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUserMetricStatisticError_6.GatewayTimeoutError,
        GenericError: GetTeamUserMetricStatisticError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserReceiptError: {
        InvalidParameterError: GetTeamUserReceiptError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptError_3.UnauthorizedError,
        NotFoundError: GetTeamUserReceiptError_4.NotFoundError,
        InternalServerError: GetTeamUserReceiptError_5.InternalServerError,
        BadGatewayError: GetTeamUserReceiptError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptError_7.GatewayTimeoutError,
        GenericError: GetTeamUserReceiptError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserReceiptFileError: {
        InvalidParameterError: GetTeamUserReceiptFileError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptFileError_3.UnauthorizedError,
        ForbiddenError: GetTeamUserReceiptFileError_4.ForbiddenError,
        NotFoundError: GetTeamUserReceiptFileError_5.NotFoundError,
        InternalServerError: GetTeamUserReceiptFileError_6.InternalServerError,
        BadGatewayError: GetTeamUserReceiptFileError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptFileError_8.GatewayTimeoutError,
        GenericError: GetTeamUserReceiptFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserTransferError: {
        InvalidParameterError: GetTeamUserTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserTransferError_3.UnauthorizedError,
        NotFoundError: GetTeamUserTransferError_4.NotFoundError,
        InternalServerError: GetTeamUserTransferError_5.InternalServerError,
        BadGatewayError: GetTeamUserTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamUserTransferError_7.GatewayTimeoutError,
        GenericError: GetTeamUserTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamUserUsageError: {
        InvalidParameterError: GetTeamUserUsageError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserUsageError_3.UnauthorizedError,
        InternalServerError: GetTeamUserUsageError_4.InternalServerError,
        BadGatewayError: GetTeamUserUsageError_5.BadGatewayError,
        GatewayTimeoutError: GetTeamUserUsageError_6.GatewayTimeoutError,
        GenericError: GetTeamUserUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferError: {
        InvalidParameterError: GetTransferError_2.InvalidParameterError,
        UnauthorizedError: GetTransferError_3.UnauthorizedError,
        NotFoundError: GetTransferError_4.NotFoundError,
        InternalServerError: GetTransferError_5.InternalServerError,
        BadGatewayError: GetTransferError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferError_7.GatewayTimeoutError,
        GenericError: GetTransferError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFileError: {
        InvalidParameterError: GetTransferFileError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFileError_3.UnauthorizedError,
        NotFoundError: GetTransferFileError_4.NotFoundError,
        InternalServerError: GetTransferFileError_5.InternalServerError,
        BadGatewayError: GetTransferFileError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferFileError_7.GatewayTimeoutError,
        GenericError: GetTransferFileError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFileInternalError: {
        InvalidParameterError: GetTransferFileInternalError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFileInternalError_3.UnauthorizedError,
        NotFoundError: GetTransferFileInternalError_4.NotFoundError,
        InternalServerError: GetTransferFileInternalError_5.InternalServerError,
        BadGatewayError: GetTransferFileInternalError_6.BadGatewayError,
        GatewayTimeoutError: GetTransferFileInternalError_7.GatewayTimeoutError,
        GenericError: GetTransferFileInternalError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTransferFilePreviewError: {
        InvalidParameterError: GetTransferFilePreviewError_2.InvalidParameterError,
        UnauthorizedError: GetTransferFilePreviewError_3.UnauthorizedError,
        PasswordDoesNotMatchError: GetTransferFilePreviewError_4.PasswordDoesNotMatchError,
        NotFoundError: GetTransferFilePreviewError_5.NotFoundError,
        InternalServerError: GetTransferFilePreviewError_6.InternalServerError,
        BadGatewayError: GetTransferFilePreviewError_7.BadGatewayError,
        GatewayTimeoutError: GetTransferFilePreviewError_8.GatewayTimeoutError,
        GenericError: GetTransferFilePreviewError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DownloadError: {
        BadRequestError: DownloadError_2.BadRequestError,
        UnauthorizedError: DownloadError_3.UnauthorizedError,
        FobiddenError: DownloadError_4.FobiddenError,
        NotFoundError: DownloadError_5.NotFoundError,
        InternalServerError: DownloadError_6.InternalServerError,
        BadGatewayError: DownloadError_7.BadGatewayError,
        GatewayTimeoutError: DownloadError_8.GatewayTimeoutError,
        GenericError: DownloadError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UploadTransferFilePartError: {
        BadRequestError: UploadTransferFilePartError_2.BadRequestError,
        InternalServerError: UploadTransferFilePartError_3.InternalServerError,
        NotFoundError: UploadTransferFilePartError_4.NotFoundError,
        NoSuchUploadError: UploadTransferFilePartError_5.NoSuchUploadError,
        AccessControlListNotSupportedError: UploadTransferFilePartError_6.AccessControlListNotSupportedError,
        AccessDeniedError: UploadTransferFilePartError_7.AccessDeniedError,
        AccessPointAlreadyOwnedByYouError: UploadTransferFilePartError_8.AccessPointAlreadyOwnedByYouError,
        AccountProblemError: UploadTransferFilePartError_9.AccountProblemError,
        AllAccessDisabledError: UploadTransferFilePartError_10.AllAccessDisabledError,
        AmbiguousGrantByEmailAddressError: UploadTransferFilePartError_11.AmbiguousGrantByEmailAddressError,
        AuthorizationHeaderMalformedError: UploadTransferFilePartError_12.AuthorizationHeaderMalformedError,
        BadDigestError: UploadTransferFilePartError_13.BadDigestError,
        EntityTooSmallError: UploadTransferFilePartError_14.EntityTooSmallError,
        EntityTooLargeError: UploadTransferFilePartError_15.EntityTooLargeError,
        ExpiredTokenError: UploadTransferFilePartError_16.ExpiredTokenError,
        IllegalLocationConstraintExceptionError: UploadTransferFilePartError_17.IllegalLocationConstraintExceptionError,
        IllegalVersioningConfigurationExceptionError: UploadTransferFilePartError_18.IllegalVersioningConfigurationExceptionError,
        IncompleteBodyError: UploadTransferFilePartError_19.IncompleteBodyError,
        InlineDataTooLargeError: UploadTransferFilePartError_20.InlineDataTooLargeError,
        InternalError: UploadTransferFilePartError_21.InternalError,
        InvalidAccessKeyIdError: UploadTransferFilePartError_22.InvalidAccessKeyIdError,
        InvalidArgumentError: UploadTransferFilePartError_23.InvalidArgumentError,
        InvalidBucketNameError: UploadTransferFilePartError_24.InvalidBucketNameError,
        InvalidBucketStateError: UploadTransferFilePartError_25.InvalidBucketStateError,
        InvalidDigestError: UploadTransferFilePartError_26.InvalidDigestError,
        InvalidLocationConstraintError: UploadTransferFilePartError_27.InvalidLocationConstraintError,
        InvalidObjectStateError: UploadTransferFilePartError_28.InvalidObjectStateError,
        InvalidPartError: UploadTransferFilePartError_29.InvalidPartError,
        InvalidPartOrderError: UploadTransferFilePartError_30.InvalidPartOrderError,
        InvalidPayerError: UploadTransferFilePartError_31.InvalidPayerError,
        InvalidPolicyDocumentError: UploadTransferFilePartError_32.InvalidPolicyDocumentError,
        InvalidRangeError: UploadTransferFilePartError_33.InvalidRangeError,
        InvalidRequestError: UploadTransferFilePartError_34.InvalidRequestError,
        InvalidSecurityError: UploadTransferFilePartError_35.InvalidSecurityError,
        InvalidTokenError: UploadTransferFilePartError_36.InvalidTokenError,
        InvalidURIError: UploadTransferFilePartError_37.InvalidURIError,
        KeyTooLongError: UploadTransferFilePartError_38.KeyTooLongError,
        MaxMessageLengthExceededError: UploadTransferFilePartError_39.MaxMessageLengthExceededError,
        MetadataTooLargeError: UploadTransferFilePartError_40.MetadataTooLargeError,
        MissingContentLengthError: UploadTransferFilePartError_41.MissingContentLengthError,
        MissingRequestBodyError: UploadTransferFilePartError_42.MissingRequestBodyError,
        MissingSecurityHeaderError: UploadTransferFilePartError_43.MissingSecurityHeaderError,
        NoSuchBucketError: UploadTransferFilePartError_44.NoSuchBucketError,
        NoSuchBucketPolicyError: UploadTransferFilePartError_45.NoSuchBucketPolicyError,
        NoSuchCORSConfigurationError: UploadTransferFilePartError_46.NoSuchCORSConfigurationError,
        NoSuchKeyError: UploadTransferFilePartError_47.NoSuchKeyError,
        NotImplementedError: UploadTransferFilePartError_48.NotImplementedError,
        RequestHeaderSectionTooLargeError: UploadTransferFilePartError_49.RequestHeaderSectionTooLargeError,
        RequestTimeoutError: UploadTransferFilePartError_50.RequestTimeoutError,
        RequestTimeTooSkewedError: UploadTransferFilePartError_51.RequestTimeTooSkewedError,
        ServerSideEncryptionConfigurationNotFoundError: UploadTransferFilePartError_52.ServerSideEncryptionConfigurationNotFoundError,
        ServiceUnavailableError: UploadTransferFilePartError_53.ServiceUnavailableError,
        SignatureDoesNotMatchError: UploadTransferFilePartError_54.SignatureDoesNotMatchError,
        SlowDownError: UploadTransferFilePartError_55.SlowDownError,
        TokenRefreshRequiredError: UploadTransferFilePartError_56.TokenRefreshRequiredError,
        UnexpectedContentError: UploadTransferFilePartError_57.UnexpectedContentError,
        UserKeyMustBeSpecifiedError: UploadTransferFilePartError_58.UserKeyMustBeSpecifiedError,
        EtagIsMissingError: UploadTransferFilePartError_59.EtagIsMissingError,
        GenericError: UploadTransferFilePartError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
